import { useState, useEffect, useRef, useCallback, Fragment, forwardRef, useImperativeHandle } from 'react'
import api from '../api'
import TrialSignupModal, { formatTeacherPhone, telHref } from './TrialSignupModal'
import BirzhaModal from './BirzhaModal'
import CallReviewCard from './CallReviewCard'
import BirzhaTab from './BirzhaTab'
import TrialsBoard from './TrialsBoard'
import { PriceLine, TrialButton, BookedTrialsList, trialButtonLabel, isNonEmpty } from './LessonBookingBlock'
import ReportIssueButton from '../components/ReportIssueButton'
import { pullOldMk, PULL_OLDMK_LABEL, PULL_OLDMK_TITLE } from './pullOldMk'

// ─────────── Icons ───────────
const I = ({ size = 16, children, className = '', stroke = 'currentColor', fill = 'none', strokeWidth = 1.6 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={stroke} strokeWidth={strokeWidth}
       strokeLinecap="round" strokeLinejoin="round" className={className}>{children}</svg>
)
const IconPhoneIn = (p) => <I {...p}><path d="M15 2v5h5"/><path d="M20 2 15 7"/><path d="M21 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 1.12 4.18 2 2 0 0 1 3.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L7.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72a2 2 0 0 1 1.72 2z"/></I>
const IconPhoneOut = (p) => <I {...p}><path d="M23 7V2h-5"/><path d="M18 7 23 2"/><path d="M21 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 1.12 4.18 2 2 0 0 1 3.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L7.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72a2 2 0 0 1 1.72 2z"/></I>
const IconCheck = (p) => <I {...p}><path d="M20 6 9 17l-5-5"/></I>
const IconX = (p) => <I {...p}><path d="M18 6 6 18"/><path d="m6 6 12 12"/></I>
const IconPlay = (p) => <I {...p} fill="currentColor" stroke="none"><path d="M8 5v14l11-7z"/></I>
const IconPause = (p) => <I {...p} fill="currentColor" stroke="none"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></I>
const IconChevron = (p) => <I {...p}><path d="m9 18 6-6-6-6"/></I>
const IconLogout = (p) => <I {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/></I>
const IconClock = (p) => <I {...p}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></I>
const IconCalendar = (p) => <I {...p}><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></I>
const IconSearch = (p) => <I {...p}><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></I>
const IconGear = (p) => <I {...p}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6 1.65 1.65 0 0 0 10 3.09V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.14.35.4.65.73.85.3.18.64.26.98.25H21a2 2 0 1 1 0 4h-.09c-.68 0-1.3.4-1.51 1Z"/></I>
const IconSparkle = (p) => <I {...p}><path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8"/></I>
const IconAlert = (p) => <I {...p}><path d="M12 9v4M12 17h.01"/><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></I>
const IconBulb = (p) => <I {...p}><path d="M9 18h6"/><path d="M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.74V17h8v-2.26A7 7 0 0 0 12 2z"/></I>
const IconUser = (p) => <I {...p}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></I>
const IconCrown = (p) => <I {...p} fill="currentColor" stroke="none"><path d="M5 18h14l1.5-9-4.5 3-3.5-5-3.5 5-4.5-3L5 18zM4 20h16v1.5H4V20z"/></I>

// ─────────── Survey field definitions ───────────
const CONTACT_FIELDS = [
  { key: 'phone',         label: 'Телефон',              kind: 'text',   required: false, tint: 'sky' },
  { key: 'parentPhone',   label: 'Тел. родителя',        kind: 'text',   required: false, tint: 'sky' },
  { key: 'parentName',    label: 'Имя родителя',         kind: 'text',   required: false },
  { key: 'sourceChannel', label: 'Откуда пришёл',        kind: 'select', required: true,
    options: ['Сайт','ВКонтакте','Рекомендация знакомых','Яндекс услуги','Обзвон старой базы','Блог','Школа блогинга','лингва','Другое'] },
  { key: 'goal',          label: 'Что хотите от репетитора', kind: 'select', required: true,
    options: ['Подтянуть оценки','Подготовка к ОГЭ','Подготовка к ЕГЭ','Помощь с ДЗ','Углублённые знания','Подготовка к олимпиаде'] },
  { key: 'source',        label: 'Источник',             kind: 'text',   required: false },
  { key: 'sourceDetail',  label: 'Реклама/кампания',     kind: 'text',   required: false },
  { key: 'city',          label: 'Город',                kind: 'text',   required: false },
]

const CHILD_FIELDS = [
  { key: 'childName', label: 'Имя Фамилия ребёнка', kind: 'text',   required: true, placeholder: 'Иван Иванов' },
  { key: 'childPhone', label: 'Телефон ребёнка',    kind: 'text',   required: false },
  { key: 'classNum',  label: 'Класс',                kind: 'select', required: true,
    options: ['Дошкольник','1 класс','2 класс','3 класс','4 класс','5 класс','6 класс','7 класс','8 класс','9 класс','10 класс','11 класс','Колледж или Техникум'] },
  { key: 'subject',   label: 'Предмет',              kind: 'select', required: true,
    options: ['Математика','Математика ОГЭ','Математика ЕГЭ','Русский язык','Русский язык ОГЭ','Русский язык ЕГЭ','Английский язык','Английский язык ОГЭ','Английский язык ЕГЭ','Физика','Физика ОГЭ','Физика ЕГЭ','Химия','Химия ОГЭ','Химия ЕГЭ','Биология','Биология ОГЭ','Биология ЕГЭ','Информатика','Информатика ОГЭ','Информатика ЕГЭ','Обществознание','Обществознание ОГЭ','Обществознание ЕГЭ','История','История ОГЭ','История ЕГЭ','География','География ОГЭ','Окружающий мир','Немецкий','Китайский язык','Турецкий язык','Фин.грамостность','Психология','Блогинг','Дошкольник Математика'] },
  { key: 'scoreNow',  label: 'Оценка сейчас',        kind: 'select', required: true, options: ['2','3','4','5'] },
  { key: 'scorePrev', label: 'Оценка в прошлом году', kind: 'select', required: true, options: ['2','3','4','5'] },
]

// Психология (14.10): вместо класса и оценок — возраст ребёнка и вопросы с анкеты психолога.
const PSY_FIELDS = [
  { key: 'psyAge',       label: 'Возраст ребёнка',    kind: 'select', required: true,
    options: ['До 3 лет','3-6 лет (дошкольник)','7-11 лет (младшая группа)','12-17 лет (подросток)'] },
  { key: 'psyCharacter', label: 'Характер',           kind: 'select', required: false,
    options: ['Активный','Стеснительный','Агрессивный','Тихий'] },
  { key: 'psyProblem',   label: 'Проблема',           kind: 'select', required: true,
    options: ['Тревожность, страхи, фобии','Агрессия, истерики, непослушание','Проблемы в школе, нежелание учиться','Замкнутость, нет друзей','Развод, стресс в семье','Другое'] },
  { key: 'psyDuration',  label: 'Как давно проблема', kind: 'select', required: true,
    options: ['Недавно (до месяца)','Несколько месяцев','Больше года'] },
]
const isPsySubject = (s) => /^психолог/i.test(String(s || '').trim())
// Поля анкеты ребёнка под предмет: у психологии класс и оценки заменены на PSY_FIELDS.
const childFieldsFor = (fields, subject) => {
  if (!isPsySubject(subject)) return fields
  const out = []
  for (const f of fields) {
    if (f.key === 'classNum' || f.key === 'scoreNow' || f.key === 'scorePrev') continue
    out.push(f)
    if (f.key === 'subject') out.push(...PSY_FIELDS)
  }
  return out
}
// «Что хотите от репетитора» психологии не нужно
const contactFieldsFor = (fields, subject) => isPsySubject(subject) ? fields.filter(f => f.key !== 'goal') : fields

const ALL_FIELDS = [...CONTACT_FIELDS, ...CHILD_FIELDS]
const REQUIRED_KEYS = ALL_FIELDS.filter(f => f.required).map(f => f.key)
// Доп. дети (вкладки «Ребёнок 2/3...») не имеют своего «Телефон ребёнка» — это
// поле только у первого (см. lead_children в db.js, там колонки child_phone нет).
const CHILD_FIELDS_EXTRA = CHILD_FIELDS.filter(f => f.key !== 'childPhone')
const CONTACT_REQUIRED_KEYS = CONTACT_FIELDS.filter(f => f.required).map(f => f.key)
const CHILD_REQUIRED_KEYS = CHILD_FIELDS_EXTRA.filter(f => f.required).map(f => f.key)
// В форме ручного добавления «Источник» не показываем — это служебное поле для лидов с сайта,
// у вручную заведённой сделки source и так проставляется на бэке ('manual').
const MANUAL_CONTACT_FIELDS = CONTACT_FIELDS.filter(f => f.key !== 'source' && f.key !== 'sourceDetail')

const DURATION_OPTS = ['30 мин - бесплатный','45 мин - 600руб','45 мин - 750руб','60 мин - 800 руб','60 мин - 1000руб','60 мин - 1200 руб','60 мин - 1400 руб','60 мин - группа','90 мин - 1200руб','90 мин - 1500 руб','90 мин - 1800','120 мин - 1600 руб','120 мин - 2000руб']
const VARIANT_OPTS  = ['Пробный бесплатный','Пробный платный (1 платный урок)','Платный постоянный','Групповой урок']
const WEEKDAYS = ['Пн','Вт','Ср','Чт','Пт','Сб','Вс']

// Зеркало серверной lessonPriceFor (katangens-platform/pricing/dao.ts) — только для показа
// звонильщику на звонке. Настоящая цена считается на платформе в момент брони.
// С 13.07 статус «Лидер» не зависит от предмета (см. project_kp_leader_pricing) — поэтому
// зеркало тоже не смотрит на предмет, только на класс ученика.
function countRequired(values) {
  return countRequiredForChild(values, values)
}
// Сколько обязательных полей заполнено для АКТИВНОГО ребёнка: контакты (общие
// на сделку) + анкета этого конкретного ребёнка (главного или доп. вкладки).
function countRequiredForChild(values, childValues) {
  const { contact, child } = requiredKeysFor(childValues)
  const contactDone = contact.reduce((n, k) => n + (isNonEmpty(values[k]) ? 1 : 0), 0)
  const childDone = child.reduce((n, k) => n + (isNonEmpty(childValues[k]) ? 1 : 0), 0)
  return contactDone + childDone
}
// Обязательные ключи под предмет активного ребёнка (у психологии свой набор).
function requiredKeysFor(childValues) {
  const psy = isPsySubject(childValues && childValues.subject)
  return {
    contact: contactFieldsFor(CONTACT_FIELDS, psy ? 'Психология' : '').filter(f => f.required).map(f => f.key),
    child: childFieldsFor(CHILD_FIELDS_EXTRA, psy ? 'Психология' : '').filter(f => f.required).map(f => f.key),
  }
}
function requiredTotalFor(childValues) {
  const { contact, child } = requiredKeysFor(childValues)
  return contact.length + child.length
}

// ─────────── Helpers ───────────
function scoreColor(score) {
  if (score >= 8) return { bg: '#ECFDF5', ring: '#A7F3D0', text: '#047857', dot: '#10B981', label: 'Хорошо' }
  if (score >= 5) return { bg: '#FFFBEB', ring: '#FDE68A', text: '#B45309', dot: '#F59E0B', label: 'Средне' }
  return { bg: '#FEF2F2', ring: '#FECACA', text: '#B91C1C', dot: '#EF4444', label: 'Низко' }
}
function tagToStatus(tag) {
  if (tag === 'new') return 'new'
  if (tag === 'recall') return 'callback'
  if (tag === 'refuse') return 'rejected'
  return 'new'
}

function StatusBadge({ status, batchName, sourceLabel }) {
  const map = {
    new:      { bg: '#ECFDF5', ring: '#A7F3D0', text: '#047857', dot: '#10B981', label: 'Новый лид' },
    callback: { bg: '#FFFBEB', ring: '#FDE68A', text: '#B45309', dot: '#F59E0B', label: 'Перезвонить' },
    rejected: { bg: '#FEF2F2', ring: '#FECACA', text: '#B91C1C', dot: '#EF4444', label: 'Отказник' },
  }
  const s = map[status] || map.new
  // Лид из загруженной пачки: на этапе «новый» название базы заменяет «Новый лид»
  // (это и так подразумевается), на остальных этапах — дописывается к статусу.
  // Живой клиент: к статусу дописываем, ОТКУДА он пришёл («Новый лид · Авито»),
  // чтобы горячая заявка не выглядела так же, как холодный контакт из базы.
  const label = batchName
    ? (status === 'new' ? batchName : s.label + ' · ' + batchName)
    : (sourceLabel ? s.label + ' · ' + sourceLabel : s.label)
  return (
    <span className="inline-flex items-center gap-1.5 text-[12px] font-medium px-2.5 py-1 rounded-full"
          style={{ background: s.bg, color: s.text, border: `1px solid ${s.ring}` }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.dot }} />
      {label}
    </span>
  )
}

const IconPlus = (p) => <I {...p}><path d="M12 5v14M5 12h14"/></I>

// ─────────── TopBar ───────────
// Статусы сделки по-русски для выпадашки поиска
const SEARCH_STATUS_RU = {
  calling: ['в обзвоне', '#0369A1', '#E0F2FE'],
  callback: ['перезвонить', '#B45309', '#FEF3C7'],
  rejected: ['отказ', '#B91C1C', '#FEE2E2'],
  trial: ['пробный назначен', '#047857', '#D1FAE5'],
}

function TopBar({ name, onLogout, onAddDeal, onDealReturned, onOpenDeal, onOpenReports }) {
  const initials = (name || 'АС').split(' ').map(s => s[0]).join('').substring(0, 2).toUpperCase()
  const [onShift, setOnShift] = useState(false)
  const [shiftSince, setShiftSince] = useState(null)
  const [shiftBusy, setShiftBusy] = useState(false)
  // Поиск сделки по номеру/ID/имени + «Вернуть в работу» (Антон 10.08)
  const [searchQ, setSearchQ] = useState('')
  const [searchRes, setSearchRes] = useState(null) // null = выпадашка закрыта
  const [takingId, setTakingId] = useState(null)
  const searchTimer = useRef(null)
  const onSearchChange = (v) => {
    setSearchQ(v)
    clearTimeout(searchTimer.current)
    if (v.trim().length < 3) { setSearchRes(null); return }
    searchTimer.current = setTimeout(() => {
      api.get('/api/deals/search', { params: { q: v.trim() } })
        .then(r => setSearchRes(Array.isArray(r.data) ? r.data : []))
        .catch(() => setSearchRes([]))
    }, 400)
  }
  const takeDeal = async (row) => {
    if (row.status === 'trial' && !window.confirm('Эта сделка уже закрыта на пробный. Точно вернуть её в работу?')) return
    setTakingId(row.id)
    try {
      await api.post(`/api/deals/${row.id}/take`)
      setSearchRes(null); setSearchQ('')
      if (onDealReturned) onDealReturned()
    } catch (e) {
      alert(e.response?.data?.error || e.message)
    } finally {
      setTakingId(null)
    }
  }
  useEffect(() => {
    api.get('/api/shift').then(r => { setOnShift(!!r.data.on); setShiftSince(r.data.since) }).catch(() => {})
  }, [])
  const toggleShift = () => {
    if (shiftBusy) return
    const next = !onShift
    setShiftBusy(true)
    setOnShift(next)                                        // мгновенный отклик
    setShiftSince(next ? new Date().toISOString() : null)
    api.post('/api/shift', { on: next })
      .then(r => { setOnShift(!!r.data.on); setShiftSince(r.data.since) })
      .catch(() => { setOnShift(!next); alert('Не удалось изменить статус смены — обновите страницу и попробуйте снова.') })
      .finally(() => setShiftBusy(false))
  }
  // Кнопка «Задачи» в панели: свои перезвоны с датой отработки (Роман 22.10.2026).
  const [tasksOpen, setTasksOpen] = useState(false)
  const [myTasks, setMyTasks] = useState(null)
  const loadMyTasks = () => {
    setMyTasks(null)
    api.get('/api/deals/my-tasks').then(r => setMyTasks(r.data || { tasks: [] }))
      .catch(e => setMyTasks({ tasks: [], error: e.response?.data?.error || e.message }))
  }
  useEffect(() => { if (tasksOpen) loadMyTasks() }, [tasksOpen])

  const shiftSub = onShift
    ? 'на смене' + (shiftSince ? ' с ' + new Date(shiftSince).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }) : '')
    : 'смена не начата'
  const TASK_BUCKETS = [
    { key: 'overdue', title: 'Просрочено', color: '#B91C1C' },
    { key: 'today', title: 'Сегодня', color: '#B45309' },
    { key: 'later', title: 'Дальше', color: '#334155' },
    { key: 'nodate', title: 'Без срока', color: '#64748B' },
    { key: 'done', title: 'Отработано за 3 дня', color: '#047857' },
  ]
  const fmtDue = (s) => {
    const v = String(s || '').replace('T', ' ')
    if (!v) return 'без срока'
    const [d, time] = v.split(' ')
    const p = d.split('-')
    return `${p[2]}.${p[1]} ${String(time || '').slice(0, 5)}`
  }

  return (
    <>
    <header className="sticky top-0 z-30 bg-white/85 backdrop-blur border-b border-slate-200" style={{ height: 56 }}>
      <style>{`.crm-nav{gap:2px}.crm-nav>button,.crm-nav>a{padding:4px 7px;font-size:12px;white-space:nowrap;line-height:1.25}`}</style>
      <div className="h-full px-3 flex items-center gap-2">
        <div className="flex items-center gap-2.5 shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 64 64" style={{ flexShrink: 0 }}><rect width="64" height="64" rx="16" fill="#3bc8f5"/><text x="50%" y="47" fontFamily="Arial, sans-serif" fontSize="38" fontWeight="bold" fill="#ffffff" textAnchor="middle">К</text></svg>
          <div className="text-[14px] font-semibold tracking-tight">Котангенс CRM</div>
        </div>
        <span className="text-[12px] font-medium px-2.5 py-1 rounded-full shrink-0 whitespace-nowrap"
              style={{ background: '#E0F2FE', color: '#0369A1', border: '1px solid #BAE6FD' }}>
          Звонильщик
        </span>
        <button onClick={onAddDeal}
          className="flex items-center gap-1.5 text-[13px] font-semibold text-white pl-2.5 pr-3.5 py-1.5 rounded-lg shrink-0"
          style={{ background: '#38BDF8' }}>
          <IconPlus size={15}/>
          Добавить сделку
        </button>
        <nav className="hidden lg:flex items-center gap-0.5 ml-2 text-[12px] crm-nav">
          {['Сделки', 'Задачи', 'Отчёты'].map((n, i) => {   // «Звонки» убрали 22.10.2026
            const isTasks = n === 'Задачи'
            const isReports = n === 'Отчёты'
            const active = (i === 0 && !tasksOpen) || (isTasks && tasksOpen)
            const onClick = isTasks ? () => setTasksOpen(v => !v) : isReports ? onOpenReports : undefined
            return (
              <button key={n} onClick={onClick}
                title={isTasks ? 'Мои перезвоны по датам отработки' : isReports ? 'Рейтинг менеджеров и последние звонки' : undefined}
                className={`px-3 py-1.5 rounded-lg ${active ? 'bg-slate-100 text-slate-900 font-medium' : 'text-slate-500 hover:text-slate-800'} ${onClick ? 'cursor-pointer' : ''}`}>
                {n}
              </button>
            )
          })}
          <a href="/teachers" className="px-3 py-1.5 rounded-lg text-slate-500 hover:text-slate-800" style={{ textDecoration: 'none' }}>Все преподаватели</a>
        </nav>
        <div className="ml-auto hidden md:block relative w-[200px]">
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-slate-100 text-slate-500">
            <IconSearch size={14}/>
            <input placeholder="Поиск по сделкам, ID, телефону" value={searchQ}
              onChange={e => onSearchChange(e.target.value)}
              onBlur={() => setTimeout(() => setSearchRes(null), 250)}
              className="bg-transparent outline-none text-[13px] w-full placeholder:text-slate-400 text-slate-700" />
          </div>
          {searchRes !== null && (
            <div className="absolute top-full mt-1 left-0 w-[360px] max-h-[420px] overflow-auto bg-white border border-slate-200 rounded-xl shadow-xl z-50 p-1.5">
              {searchRes.length === 0 && (
                <div className="text-[12px] text-slate-400 text-center py-3">Ничего не нашлось</div>
              )}
              {searchRes.map(row => {
                const st = SEARCH_STATUS_RU[row.status] || [row.status, '#64748B', '#F1F5F9']
                return (
                  <div key={row.id} onMouseDown={e => e.preventDefault()}
                       onClick={() => { setSearchRes(null); setSearchQ(''); if (onOpenDeal) onOpenDeal(row.id) }}
                       title="Открыть сделку" className="rounded-lg px-2.5 py-2 hover:bg-slate-50 border-b border-slate-50 last:border-0 cursor-pointer">
                    <div className="flex items-center gap-2">
                      <div className="min-w-0 flex-1">
                        <div className="text-[12.5px] font-semibold text-slate-800 truncate">
                          {row.parent_name || row.child_name || 'Без имени'}
                          {row.child_name && row.parent_name ? <span className="text-slate-400 font-normal"> · {row.child_name}</span> : null}
                        </div>
                        <div className="text-[11px] text-slate-400">
                          #{row.id} · {row.phone || 'без телефона'}{row.subject ? ' · ' + row.subject : ''}
                        </div>
                      </div>
                      <span className="text-[10.5px] font-bold px-1.5 py-0.5 rounded-full shrink-0" style={{ color: st[1], background: st[2] }}>{st[0]}</span>
                    </div>
                    <div className="flex items-center justify-between mt-1">
                      <span className="text-[10.5px] text-slate-400">{row.manager_name ? 'у ' + row.manager_name : 'без менеджера'}</span>
                      <button onMouseDown={e => e.preventDefault()} onClick={(e) => { e.stopPropagation(); takeDeal(row) }} disabled={takingId === row.id}
                        className="text-[11px] font-bold text-sky-700 border border-sky-200 bg-sky-50 rounded-lg px-2 py-0.5 hover:bg-sky-100 disabled:opacity-50">
                        {takingId === row.id ? 'Возвращаю…' : 'Вернуть в работу'}
                      </button>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
        <div className="flex items-center gap-2 ml-auto md:ml-0 shrink-0">
          <button onClick={toggleShift} disabled={shiftBusy} title={onShift ? 'Снять смену' : 'Начать смену'}
            className="flex items-center gap-2 pl-2.5 pr-3 py-1.5 rounded-full text-[13px] font-semibold disabled:opacity-60"
            style={onShift ? { background: '#ECFDF5', color: '#047857', border: '1px solid #A7F3D0' }
                           : { background: '#F1F5F9', color: '#94A3B8', border: '1px solid #E2E8F0' }}>
            <span className="relative inline-block w-8 h-[18px] rounded-full" style={{ background: onShift ? '#10B981' : '#CBD5E1' }}>
              <span className="absolute top-0.5 w-3.5 h-3.5 rounded-full bg-white shadow" style={{ left: onShift ? 14 : 2 }} />
            </span>
            {onShift ? 'На смене' : 'Не на смене'}
          </button>
          <div className="text-right leading-tight hidden sm:block">
            <div className="text-[13px] font-medium text-slate-800">{name || 'Пользователь'}</div>
            <div className="text-[11px] text-slate-500">{shiftSub}</div>
          </div>
          <div className="w-8 h-8 rounded-full bg-slate-200 text-slate-600 flex items-center justify-center text-[12px] font-semibold">
            {initials}
          </div>
          <button onClick={onLogout} className="flex items-center gap-1.5 text-[12px] text-slate-500 hover:text-slate-800 px-2 py-1.5 rounded-lg hover:bg-slate-100">
            <IconLogout size={14}/>
            <span className="hidden md:inline">Выйти</span>
          </button>
        </div>
      </div>
    </header>
    {tasksOpen && (
      <div className="fixed inset-0 z-50 flex items-start justify-center p-4 pt-16"
           style={{ background: 'rgba(15,23,42,0.45)' }} onClick={() => setTasksOpen(false)}>
        <div className="w-full max-w-[760px] max-h-[82vh] overflow-auto rounded-2xl bg-white shadow-2xl"
             onClick={e => e.stopPropagation()}>
          <div className="sticky top-0 flex items-center justify-between border-b border-slate-200 bg-white px-5 py-3">
            <div className="text-[15px] font-semibold text-slate-900">Мои задачи — перезвоны по датам</div>
            <button type="button" onClick={() => setTasksOpen(false)}
              className="text-[13px] text-slate-500 hover:text-slate-800">Закрыть</button>
          </div>
          <div className="p-4">
            {!myTasks && <div className="py-6 text-center text-[13px] text-slate-400">Загрузка…</div>}
            {myTasks && myTasks.error && (
              <div className="py-6 text-center text-[13px] text-rose-600">Не удалось загрузить: {myTasks.error}</div>
            )}
            {myTasks && !myTasks.error && myTasks.tasks.length === 0 && (
              <div className="py-6 text-center text-[13px] text-slate-400">Задач нет — ни одного перезвона не поставлено</div>
            )}
            {myTasks && !myTasks.error && TASK_BUCKETS.map(b => {
              const list = myTasks.tasks.filter(x => x.bucket === b.key)
              if (!list.length) return null
              return (
                <div key={b.key} className="mb-4">
                  <div className="mb-1.5 text-[12px] font-semibold uppercase tracking-wide" style={{ color: b.color }}>
                    {b.title} · {list.length}
                  </div>
                  <div className="flex flex-col gap-1">
                    {list.map(x => (
                      <div key={x.id} onClick={() => { setTasksOpen(false); if (onOpenDeal) onOpenDeal(x.leadId) }}
                        title="Открыть сделку"
                        className="flex cursor-pointer items-center gap-3 rounded-lg border border-slate-100 px-3 py-2 hover:bg-slate-50">
                        <div className="w-[86px] shrink-0 text-[12.5px] font-semibold tabular-nums"
                             style={{ color: x.bucket === 'overdue' ? '#B91C1C' : '#334155' }}>
                          {fmtDue(x.dueAt)}
                        </div>
                        <div className="min-w-0 flex-1">
                          <div className="truncate text-[13px] font-semibold text-slate-800">
                            {x.name || 'Без имени'}
                            {x.phone ? <span className="font-normal text-slate-400"> · {x.phone}</span> : null}
                          </div>
                          <div className="truncate text-[12px] text-slate-500">
                            {x.text || x.type}
                            {x.batchName ? <span className="text-slate-400"> · {x.batchName}</span> : null}
                            {x.done && x.result ? <span className="text-emerald-700"> · {x.result}</span> : null}
                          </div>
                        </div>
                        {!x.done && x.lateMin > 0 && (
                          <div className="shrink-0 text-[11.5px] text-rose-600">
                            опоздание {x.lateMin >= 1440 ? Math.floor(x.lateMin / 1440) + ' дн' : x.lateMin >= 60 ? Math.floor(x.lateMin / 60) + ' ч' : x.lateMin + ' мин'}
                          </div>
                        )}
                        {x.done && <div className="shrink-0 text-[11.5px] text-emerald-700">закрыта</div>}
                      </div>
                    ))}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )}
    </>
  )
}

// ─────────── KPI ───────────
// Правая метка на месте «0N» — для карточек по лидам показываем период вместо номера
const SALARY_MONTHS = ['январь','февраль','март','апрель','май','июнь','июль','август','сентябрь','октябрь','ноябрь','декабрь']
function salaryMonthLabel(m) {
  const p = String(m || '').split('-')
  const i = Number(p[1]) - 1
  return SALARY_MONTHS[i] ? SALARY_MONTHS[i] : String(m || '')
}
const SALARY_RESULT = {
  stayed:  { text: 'остался',            bg: '#ECFDF5', color: '#047857', ring: '#A7F3D0' },
  left:    { text: 'не остался',         bg: '#FEF2F2', color: '#B91C1C', ring: '#FECACA' },
  noshow:  { text: 'не пришёл',          bg: '#FFFBEB', color: '#B45309', ring: '#FDE68A' },
  pending: { text: 'урок ещё не прошёл', bg: '#F1F5F9', color: '#64748B', ring: '#E2E8F0' },
}

// Разбор зарплаты: из чего сложилась сумма. Показываем ВСЕ пробные месяца, а не
// только оплаченные — человек видит, почему премия такая, и заодно получает список
// недоработанных клиентов с телефоном: по «не пришёл»/«не остался» можно позвонить
// прямо отсюда и попробовать закрыть ещё раз (Антон 03.08).
function SalaryPanel({ salary, onClose }) {
  if (!salary) return null
  const items = salary.items || []
  return (
    <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-slate-100 flex items-baseline gap-2 flex-wrap">
        <div className="text-[14px] font-bold text-slate-900">Зарплата за {salaryMonthLabel(salary.month)}</div>
        <button onClick={onClose} className="ml-auto text-[12px] text-slate-400 hover:text-slate-600">свернуть</button>
      </div>

      <div className="grid grid-cols-3 gap-px" style={{ background: '#F1F5F9' }}>
        <div className="bg-white px-4 py-3">
          <div className="text-[11.5px] text-slate-500">Оклад</div>
          <div className="text-[20px] font-bold text-slate-900">{(salary.oklad || 0).toLocaleString('ru-RU')} ₽</div>
        </div>
        <div className="bg-white px-4 py-3">
          <div className="text-[11.5px] text-slate-500">Премия · {salary.counts ? salary.counts.ostalis : 0} клиентов</div>
          <div className="text-[20px] font-bold text-slate-900">{(salary.bonus || 0).toLocaleString('ru-RU')} ₽</div>
        </div>
        <div className="bg-white px-4 py-3">
          <div className="text-[11.5px] text-slate-500">Итого за месяц</div>
          <div className="text-[20px] font-bold" style={{ color: '#047857' }}>{(salary.salary || 0).toLocaleString('ru-RU')} ₽</div>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="px-4 py-8 text-center text-[12.5px] text-slate-400">В этом месяце пробных ещё не было</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-[13px]" style={{ borderCollapse: 'collapse', minWidth: 620 }}>
            <thead>
              <tr>
                {['Дата', 'Клиент', 'Телефон', 'Цена урока', 'Результат', 'Премия'].map((h, i) => (
                  <th key={h} className="text-[10px] uppercase tracking-wider font-bold text-slate-400 px-4 py-2.5 whitespace-nowrap"
                      style={{ background: '#F8FAFC', borderBottom: '1px solid #F1F5F9', textAlign: i >= 3 && i !== 4 ? 'right' : 'left' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map(it => {
                const r = SALARY_RESULT[it.result] || SALARY_RESULT.pending
                return (
                  <tr key={it.bookingId} style={{ borderBottom: '1px solid #F5F7FA' }}>
                    <td className="px-4 py-2.5 whitespace-nowrap text-slate-600">{(it.date || '').slice(8, 10)}.{(it.date || '').slice(5, 7)}</td>
                    <td className="px-4 py-2.5 text-slate-900">{it.clientName}</td>
                    <td className="px-4 py-2.5 whitespace-nowrap">
                      {formatTeacherPhone(it.clientPhone)
                        ? <a href={telHref(it.clientPhone)} style={{ color: '#0369A1' }} className="hover:underline">{formatTeacherPhone(it.clientPhone)}</a>
                        : <span className="text-slate-300">—</span>}
                    </td>
                    <td className="px-4 py-2.5 text-right whitespace-nowrap text-slate-600">
                      {it.price ? it.price.toLocaleString('ru-RU') + ' ₽' : '—'}
                    </td>
                    <td className="px-4 py-2.5">
                      <span className="inline-block text-[10.5px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap"
                            style={{ background: r.bg, color: r.color, border: `1px solid ${r.ring}` }}>{r.text}</span>
                    </td>
                    <td className="px-4 py-2.5 text-right whitespace-nowrap font-bold"
                        style={{ color: it.bonus ? '#047857' : '#CBD5E1' }}>
                      {it.bonus ? it.bonus + ' ₽' : '—'}
                    </td>
                  </tr>
                )
              })}
              <tr style={{ background: '#F8FAFC', fontWeight: 700 }}>
                <td className="px-4 py-2.5" colSpan={5}>
                  Пробных {salary.counts ? salary.counts.vsego : items.length} · остались {salary.counts ? salary.counts.ostalis : 0}
                </td>
                <td className="px-4 py-2.5 text-right">{(salary.bonus || 0).toLocaleString('ru-RU')} ₽</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

function KpiCard({ k, idx }) {
  const green = k.tone === 'green'
  const isSplit = Array.isArray(k.split)
  return (
    <div className="rounded-2xl p-4 border" onClick={k.onClick}
         style={{ ...(green ? { background: '#ECFDF5', borderColor: '#A7F3D0' } : { background: 'white', borderColor: '#E5E7EB' }),
                  ...(k.onClick ? { cursor: 'pointer' } : null) }}>
      <div className="flex items-center justify-between">
        <div className={`text-[11px] uppercase tracking-wider font-semibold ${green ? 'text-emerald-700' : 'text-slate-500'}`}>
          {k.label || ' '}
        </div>
        <div className="text-[10px] font-mono text-slate-400">{k.corner || `0${idx + 1}`}</div>
      </div>
      {isSplit ? (
        <div className="mt-2 flex items-baseline gap-2.5">
          {k.split.map((p, i) => (
            <Fragment key={i}>
              {i > 0 && <div className="self-stretch w-px bg-slate-200" />}
              <div className="flex items-baseline gap-1">
                <span className="text-[22px] font-semibold tracking-tight text-slate-900">{p.n ?? '—'}</span>
                <span className="text-[10.5px] text-slate-500">{p.k}</span>
              </div>
            </Fragment>
          ))}
        </div>
      ) : (
        <>
          <div className={`mt-2 text-[26px] font-semibold tracking-tight ${green ? 'text-emerald-800' : 'text-slate-900'}`}>
            {k.value ?? '—'}
          </div>
          {k.hint && <div className="mt-1.5 text-[10.5px] font-semibold" style={{ color: '#059669' }}>{k.hint}</div>}
        </>
      )}
      <div className={`mt-1 text-[11px] ${green ? 'text-emerald-700' : 'text-slate-500'}`}>{k.sub || ''}</div>
      {k.extra || null}
    </div>
  )
}

// Стрелки «‹ Сегодня ›» — листают период по кругу, используются в шапке карточки «Лиды»
const LEAD_PERIOD_CYCLE = ['today', 'yesterday', 'week', 'month', 'range']
const LEAD_PERIOD_LABEL = { today: 'Сегодня', yesterday: 'Вчера', week: 'Неделя', month: 'Месяц', range: 'Период' }
function PeriodStepper({ period, onStep }) {
  return (
    <div className="flex items-center gap-1 rounded-full px-1 py-0.5" style={{ background: '#E0F2FE' }}>
      <button onClick={() => onStep(-1)} title="Предыдущий период"
        className="w-[15px] h-[15px] flex items-center justify-center rounded-full text-[11px] leading-none"
        style={{ color: '#0369A1' }}>‹</button>
      <span className="text-[10px] font-semibold whitespace-nowrap" style={{ color: '#0369A1', minWidth: 44, textAlign: 'center' }}>
        {LEAD_PERIOD_LABEL[period]}
      </span>
      <button onClick={() => onStep(1)} title="Следующий период"
        className="w-[15px] h-[15px] flex items-center justify-center rounded-full text-[11px] leading-none"
        style={{ color: '#0369A1' }}>›</button>
    </div>
  )
}

// Бейдж «город · местное время клиента», определённые по коду телефонного номера
// (см. backend phoneLocation.js). Время живое — обновляется раз в минуту.
function formatLocalTime(timezone) {
  try {
    return new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit', timeZone: timezone }).format(new Date())
  } catch {
    return null
  }
}
function PhoneLocationBadge({ city, timezone }) {
  const [time, setTime] = useState(() => formatLocalTime(timezone))
  useEffect(() => {
    setTime(formatLocalTime(timezone))
    const id = setInterval(() => setTime(formatLocalTime(timezone)), 60000)
    return () => clearInterval(id)
  }, [timezone])
  if (!time) return null
  return (
    <span title={`Определено по коду номера — может не совпадать, если клиент переехал с этим номером`}
      className="inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-[3px] rounded-full whitespace-nowrap shrink-0"
      style={{ background: '#FFFBEB', color: '#B45309', border: '1px solid #FDE68A' }}>
      <IconClock size={11} />
      {city} · {time}
    </span>
  )
}

// ─────────── Client field ───────────
function ClientField({ field, value, onChange, extra }) {
  const filled = isNonEmpty(value)
  const baseCls = "flex-1 min-w-0 border rounded-md px-2 py-[5px] text-[13px] font-medium outline-none transition-colors focus:border-sky-400"
  const style = {
    background: filled ? '#F0F9FF' : '#FFFFFF',
    borderColor: filled ? '#BAE6FD' : '#E2E8F0',
  }
  // Поле стартует readOnly и снимает его только по фокусу — известный приём
  // против автозаполнения браузера (Яндекс.Браузер, реальный случай 23.07:
  // «Телефон» визуально пустел сам собой, autocomplete=off одного не хватило).
  // Многие менеджеры автозаполнения не трогают readOnly-поля при загрузке страницы.
  const [locked, setLocked] = useState(true)
  return (
    <label className="flex items-start gap-3 py-2 border-b border-slate-100 last:border-b-0">
      <div className="w-[140px] shrink-0 text-[12px] text-slate-500 leading-tight pt-[6px]">
        {field.label}
        {field.required && <span className="text-red-500 ml-0.5">*</span>}
      </div>
      <div className="flex-1 min-w-0 flex items-center gap-2 flex-wrap">
        {field.kind === 'text' && (
          <input type="text" value={value || ''} placeholder={field.placeholder || ''}
            onChange={e => onChange(e.target.value)}
            readOnly={locked} onFocus={() => setLocked(false)} onBlur={() => setLocked(true)}
            autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" data-lpignore="true" data-form-type="other"
            className={`${baseCls} placeholder:text-slate-400 ${field.tint === 'sky' ? 'text-sky-600' : 'text-slate-800'}`}
            style={style} />
        )}
        {/* Телефон дублируем ОБЫЧНЫМ ТЕКСТОМ (не полем ввода): Яндекс.Браузер трижды
            визуально стирал input «Телефон» (лид #81 23.07, сделка 6440 04.08) —
            autocomplete=off и readOnly его не останавливают. Текст из React-state
            автозаполнение тронуть не может, номер виден всегда. */}
        {field.kind === 'text' && /^7\d{10}$/.test(String(value || '').replace(/\D/g, '')) && (
          <a href={'tel:+' + String(value || '').replace(/\D/g, '')}
             className="text-[12px] font-semibold text-sky-700 whitespace-nowrap select-all"
             title="Номер из базы — виден, даже если браузер очистил поле">
            {String(value || '').replace(/\D/g, '')}
          </a>
        )}
        {field.key === 'phone' && /^7\d{10}$/.test(String(value || '').replace(/\D/g, '')) && (
          <MaxCheckButton phone={value} clientName={field.clientName} />
        )}
        {field.kind === 'textarea' && (
          <textarea value={value || ''} placeholder={field.placeholder || ''} rows={2}
            onChange={e => onChange(e.target.value)}
            className={`${baseCls} resize-none placeholder:text-slate-400 text-slate-800`}
            style={style} />
        )}
        {field.kind === 'select' && (
          <select value={value || ''} onChange={e => onChange(e.target.value)}
            className={`${baseCls} appearance-none pr-7 text-slate-800`}
            style={{
              ...style,
              backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>\")",
              backgroundRepeat: 'no-repeat', backgroundPosition: 'right 8px center',
            }}>
            <option value="">— выберите —</option>
            {field.options.map(o => <option key={o} value={o}>{o}</option>)}
          </select>
        )}
        {extra}
      </div>
    </label>
  )
}

// ─────────── Client block ───────────
// activeChildIdx: 0 = главный ребёнок (поля прямо в values/onUpdate, как раньше),
// 1+ = вкладка extraChildren[activeChildIdx-1] (своё хранилище, своё сохранение).
function ClientBlock({
  values, onUpdate, onUpdateMany, saveStatus,
  extraChildren = [], activeChildIdx = 0, onSwitchChild, onAddChild, onRemoveChild, onUpdateChild,
}) {
  const activeExtra = activeChildIdx > 0 ? extraChildren[activeChildIdx - 1] : null
  const childValues = activeExtra || values
  const childOnChange = (key, v) => activeExtra ? onUpdateChild(activeExtra.id, key, v) : onUpdate(key, v)
  const childFieldsList = childFieldsFor(activeExtra ? CHILD_FIELDS_EXTRA : CHILD_FIELDS, childValues.subject)

  const done = activeExtra ? countRequiredForChild(values, childValues) : countRequired(values)
  const total = requiredTotalFor(childValues)
  const badge =
    done < 3 ? { bg: '#FEF2F2', ring: '#FECACA', text: '#B91C1C', dot: '#EF4444' } :
    done < 7 ? { bg: '#FFFBEB', ring: '#FDE68A', text: '#B45309', dot: '#F59E0B' } :
               { bg: '#ECFDF5', ring: '#A7F3D0', text: '#047857', dot: '#10B981' }

  return (
    <div className="mb-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-0">
        <div>
          <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold pb-1.5 mb-1 border-b border-slate-100">
            Контакты и источник
          </div>
          {contactFieldsFor(CONTACT_FIELDS, childValues.subject).map(f => (
            <ClientField key={f.key} field={f} value={values[f.key]} onChange={v => onUpdate(f.key, v)}
              extra={f.key === 'phone' && values.phoneCity && values.phoneTimezone
                ? <PhoneLocationBadge city={values.phoneCity} timezone={values.phoneTimezone} />
                : null} />
          ))}
        </div>
        <div>
          <div className="flex items-center justify-between pb-1.5 mb-1 border-b border-slate-100">
            <div className="flex items-center gap-1.5 flex-wrap">
              <button type="button" onClick={() => onSwitchChild(0)}
                className="text-[11px] font-semibold px-2.5 py-1 rounded-full transition-colors"
                style={activeChildIdx === 0
                  ? { background: '#E0F2FE', color: '#0284C7' }
                  : { background: '#F8FAFC', color: '#64748B', border: '1px solid #E2E8F0' }}>
                Ребёнок 1
              </button>
              {extraChildren.map((c, i) => (
                <button key={c.id} type="button" onClick={() => onSwitchChild(i + 1)}
                  className="text-[11px] font-semibold px-2.5 py-1 rounded-full transition-colors"
                  style={activeChildIdx === i + 1
                    ? { background: '#E0F2FE', color: '#0284C7' }
                    : { background: '#F8FAFC', color: '#64748B', border: '1px solid #E2E8F0' }}>
                  {c.childName ? c.childName : `Ребёнок ${i + 2}`}
                </button>
              ))}
              <button type="button" onClick={onAddChild}
                className="w-5 h-5 rounded-full flex items-center justify-center text-white shrink-0"
                style={{ background: '#38BDF8', fontSize: 12, lineHeight: 1 }} title="Добавить ребёнка">
                +
              </button>
            </div>
            {activeExtra && (
              <button type="button" onClick={() => onRemoveChild(activeExtra.id)}
                className="text-[11px] font-semibold shrink-0" style={{ color: '#94A3B8' }}>
                ✕ убрать
              </button>
            )}
          </div>
          {childFieldsList.map(f => (
            <ClientField key={f.key} field={f} value={childValues[f.key]} onChange={v => childOnChange(f.key, v)} />
          ))}
          {isNonEmpty(childValues.subject) && !isPsySubject(childValues.subject) && (
            /* Не <label>: клик по тексту строки браузер переводит на первую кнопку внутри
               (в состоянии «цена проставлена» это «сбросить») — и цена обнулялась сразу
               после «Применить» (Роман 03.11.2026). */
            <div className="flex items-start gap-3 py-2 border-b border-slate-100 last:border-b-0">
              <div className="w-[140px] shrink-0 text-[12px] text-slate-500 leading-tight pt-[6px]">Цена урока</div>
              <div className="flex-1 min-w-0">
                {/* 29.09 (Антон): строка и у вкладок «Ребёнок 2/3…» — цена по классу ЭТОГО ребёнка,
                    скидка хранится на ребёнке (lead_children.price_override), а не на сделке. */}
                <PriceLine classNum={childValues.classNum} priceOverride={childValues.priceOverride}
                  onSet={(price, age) => activeExtra
                    ? onUpdateChild(activeExtra.id, { priceOverride: price, priceOverrideAge: age })
                    : (onUpdateMany ? onUpdateMany({ priceOverride: price, priceOverrideAge: age }) : onUpdate('priceOverride', price))}
                  onReset={() => activeExtra
                    ? onUpdateChild(activeExtra.id, { priceOverride: '', priceOverrideAge: '' })
                    : (onUpdateMany ? onUpdateMany({ priceOverride: '', priceOverrideAge: '' }) : onUpdate('priceOverride', ''))} />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <div className="text-[11px] text-slate-400">
          {saveStatus === 'saving' && '💾 Сохраняю...'}
          {saveStatus === 'saved' && <span className="text-emerald-600">✓ Сохранено</span>}
          {saveStatus === 'error' && <span className="text-red-600">⚠ Ошибка сохранения</span>}
        </div>
        <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full"
          style={{ background: badge.bg, color: badge.text, border: `1px solid ${badge.ring}` }}>
          <span className="w-1.5 h-1.5 rounded-full" style={{ background: badge.dot }} />
          Заполнено {done}/{total} обязательных
        </span>
      </div>
    </div>
  )
}

// ─────────── Добавить сделку самому ───────────
function AddDealModal({ open, onClose, onCreate, initial }) {
  const [values, setValues] = useState(initial || {})
  // initial — телефон/имя из чата переписчика (07.09): при открытии подставляем, при закрытии сбрасываем
  useEffect(() => { if (open) setValues(initial || {}) }, [open, initial])
  const [saving, setSaving] = useState(false)
  if (!open) return null

  const done = countRequired(values)
  const total = requiredTotalFor(values)
  // Менеджер может не знать всю анкету сразу (13.07: сделку заводить с тем, что
  // есть) — сохранить можно с одним телефоном, а «Записать на пробный» по-прежнему
  // требует полную анкету 7/7 (гейт на canTrial в карточке сделки, см. ниже).
  const canCreate = isNonEmpty(values.phone) && !saving
  const update = (k, v) => setValues(prev => ({ ...prev, [k]: v }))
  const submit = () => {
    if (!canCreate) return
    setSaving(true)
    onCreate(values).finally(() => setSaving(false))
  }

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 overflow-auto"
         style={{ background: 'rgba(15,23,42,0.5)', backdropFilter: 'blur(4px)' }} onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[720px] mt-10 flex flex-col overflow-hidden"
           onClick={e => e.stopPropagation()}>
        <div className="px-6 py-4 border-b border-slate-200 flex items-center gap-4">
          <div>
            <div className="text-[16px] font-semibold text-slate-900">Новая сделка</div>
            <div className="text-[12px] text-slate-500 mt-0.5">Заполни, что знаешь — сделка сразу появится у тебя в работе</div>
          </div>
          <button onClick={onClose} className="ml-auto w-8 h-8 rounded-lg border border-slate-200 text-slate-500 hover:bg-slate-50 flex items-center justify-center">
            <IconX size={15}/>
          </button>
        </div>

        <div className="px-6 py-4 overflow-auto" style={{ maxHeight: '62vh' }}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-0">
            <div>
              <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold pb-1.5 mb-1 border-b border-slate-100">
                Контакты и источник
              </div>
              {contactFieldsFor(MANUAL_CONTACT_FIELDS, values.subject).map(f => (
                <ClientField key={f.key} field={f} value={values[f.key]} onChange={v => update(f.key, v)} />
              ))}
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold pb-1.5 mb-1 border-b border-slate-100">
                Анкета ребёнка
              </div>
              {childFieldsFor(CHILD_FIELDS, values.subject).map(f => (
                <ClientField key={f.key} field={f} value={values[f.key]} onChange={v => update(f.key, v)} />
              ))}
            </div>
          </div>
        </div>

        <div className="px-6 py-3.5 border-t border-slate-200 bg-slate-50 flex items-center gap-3">
          <span className="text-[12px] text-slate-400">
            Анкета: <b className="text-amber-700">{done}/{total}</b> — для записи на пробный понадобится 7/7, сохранить можно и раньше
          </span>
          <button onClick={onClose}
            className="ml-auto px-4 py-2 rounded-lg border border-slate-200 bg-white text-slate-600 text-[13px] font-semibold">
            Отмена
          </button>
          <button onClick={submit} disabled={!canCreate}
            className="px-4 py-2 rounded-lg text-white text-[13px] font-bold disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ background: '#38BDF8' }}>
            {saving ? 'Создаю...' : 'Создать сделку'}
          </button>
        </div>
      </div>
    </div>
  )
}

// ─────────── Task block ───────────
function TaskBlock({ task, onComplete }) {
  const [result, setResult] = useState('')
  if (!task) return null
  const dateStr = task.complete_till ? new Date(task.complete_till * 1000).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : ''
  return (
    <div className="rounded-xl p-3.5" style={{ background: '#FFF7ED', border: '1px solid #FDE68A' }}>
      <div className="flex items-start gap-3">
        <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0 mt-0.5"
              style={{ background: '#FEF3C7', color: '#92400E' }}>
          <IconClock size={13}/>
        </span>
        <div className="flex-1">
          <div className="flex items-start justify-between gap-3">
            <div className="text-[13px] leading-snug">
              <span className="font-semibold text-slate-900">Задача: </span>
              <span className="text-slate-700">{task.text}</span>
            </div>
            {dateStr && (
              <div className="text-[11px] font-medium text-amber-700 shrink-0 bg-white/70 border border-amber-200 rounded-full px-2 py-0.5">
                {dateStr}
              </div>
            )}
          </div>
          {(task.createdBy || task.created_at) && (
            <div className="text-[11px] text-amber-700/80 mt-0.5">
              {task.createdBy ? 'Поставил(а): ' + task.createdBy : 'Поставлена'}
              {task.created_at ? ' · ' + task.created_at.slice(8, 10) + '.' + task.created_at.slice(5, 7) + ', ' + task.created_at.slice(11, 16) : ''}
            </div>
          )}
          <div className="flex items-center gap-2 mt-3">
            <input value={result} onChange={(e) => setResult(e.target.value)} placeholder="Результат…"
                   className="flex-1 text-[13px] bg-white border border-amber-200 rounded-lg px-3 py-2 outline-none focus:border-amber-400 placeholder:text-amber-800/40" />
            <button onClick={() => { onComplete(task.id, result); setResult('') }}
                    className="text-[13px] font-semibold text-white px-4 py-2 rounded-lg" style={{ background: '#10B981' }}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

// Закрытые задачи сделки (Перезвонить/Отказ и т.д.) — видно, что менеджер уже
// пробовал раньше, даже когда новая задача уже заменила старую в очереди.
function TaskHistory({ leadId }) {
  const [open, setOpen] = useState(false)
  const [items, setItems] = useState(null)

  const toggle = () => {
    const next = !open
    setOpen(next)
    if (next && items === null) {
      api.get('/api/tasks/history?leadId=' + leadId).then(r => setItems(r.data || [])).catch(() => setItems([]))
    }
  }

  const closed = (items || []).filter(t => t.done)
  if (items !== null && closed.length === 0) return null

  const fmt = (s) => {
    if (!s) return ''
    const datePart = s.slice(0, 10).split('-').reverse().slice(0, 2).join('.')
    const timePart = s.slice(11, 16)
    return datePart + ', ' + timePart
  }

  return (
    <div className="mt-2.5">
      <div className="flex items-center gap-1.5 text-[12px] font-semibold text-slate-500 cursor-pointer select-none py-1"
           onClick={toggle}>
        <span style={{ display: 'inline-block', fontSize: 9, transition: 'transform .15s', transform: open ? 'rotate(90deg)' : 'none' }}>▶</span>
        История задач{items ? ` (${closed.length})` : ''}
      </div>
      {open && (
        <div className="rounded-lg overflow-hidden border border-slate-100">
          {items === null ? (
            <div className="text-[12.5px] text-slate-400 px-3 py-2 bg-slate-50">Загрузка…</div>
          ) : closed.map((t, i) => (
            <div key={t.id} className="flex items-baseline gap-2 text-[12.5px] px-3 py-2"
                 style={{ background: i % 2 ? '#fff' : '#fafbfc' }}>
              <span className="text-slate-400 text-[11px] shrink-0">✓</span>
              <span className="text-slate-400 shrink-0" style={{ fontVariantNumeric: 'tabular-nums' }}>{fmt(t.created_at)}</span>
              <span className="text-slate-700">{t.text || t.type}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// Полный журнал сделки (Антон 22.07): кто и когда работал с ней и что делал —
// назначения/передачи между менеджерами, смены статуса, правки анкеты, постановка
// и закрытие задач, срочные сигналы платформы. Источник — lead_events (сырые
// события пишутся по всему бэку), тут только форматирование в читаемый текст.
const HISTORY_FIELD_LABEL = Object.fromEntries(ALL_FIELDS.map(f => [f.key, f.label]))
const HISTORY_STATUS_LABEL = { recall: 'Перезвонить', refuse: 'Отказ', trial: 'Записан на пробный', duplicate: 'Дубль' }

// Журнал приходит от новых к старым. Для правок цены подставляем значение из
// более старой записи — чтобы и в прежних событиях (сервер тогда не писал _prev)
// читалось «было → стало».
function withPrevPrice(rows) {
  const has = (m) => !!m && Object.prototype.hasOwnProperty.call(m, 'priceOverride')
  const out = rows.slice()
  for (let i = 0; i < out.length; i++) {
    if (!has(out[i] && out[i].meta)) continue
    for (let j = i + 1; j < out.length; j++) {
      if (has(out[j] && out[j].meta)) {
        out[i] = { ...out[i], prevPrice: out[j].meta.priceOverride || '' }
        break
      }
    }
  }
  return out
}

const priceText = (v) => (isNonEmpty(v) ? v + ' \u20bd' : 'стандартная по классу')

function formatHistoryEvent({ event, meta, prevPrice }) {
  switch (event) {
    case 'comment':
      return '💬 ' + ((meta && meta.text) || '')
    case 'created': {
      const src = meta && meta.source
      const label = src === 'manual' ? 'вручную звонильщиком'
        : src === 'unverified_booking' ? 'срочная — клиент забронировал урок, не подтвердил номер'
        : src ? 'с ' + src : ''
      return 'Сделка создана' + (label ? ' — ' + label : '')
    }
    case 'assigned':
      return 'Назначена: ' + ((meta && meta.manager) || '—')
    case 'reassigned':
      return 'Передана ' + ((meta && meta.from) || '?') + ' → ' + ((meta && meta.to) || '?')
        + ((meta && meta.reason) ? ' — ' + meta.reason : '')
    case 'status_change':
      return 'Статус изменён: ' + ((meta && HISTORY_STATUS_LABEL[meta.action]) || (meta && meta.status) || '?')
    case 'survey_edit': {
      // Служебные ключи (_prev, _child) в текст не выводим.
      const entries = meta ? Object.entries(meta).filter(([k]) => !k.startsWith('_')) : []
      const prev = (meta && meta._prev) || {}
      const child = (meta && meta._child) || null
      let price = null
      const parts = []
      for (const [k, v] of entries) {
        // Цена — отдельной понятной строкой: кто, когда и с чего на что поменял.
        if (k === 'priceOverride') {
          const was = Object.prototype.hasOwnProperty.call(prev, 'priceOverride') ? prev.priceOverride : prevPrice
          price = 'Цена урока' + (child ? ` (${child})` : '') + ': '
            + (was === undefined ? priceText(v) : priceText(was) + ' \u2192 ' + priceText(v))
          continue
        }
        if (k === 'priceOverrideAge') continue   // служебный возраст из старой формы скидки
        parts.push((HISTORY_FIELD_LABEL[k] || k) + ': ' + (v || '—'))
      }
      if (price && !parts.length) return price
      const text = parts.length ? 'Изменено: ' + parts.join(', ') : 'Правка анкеты'
      return price ? price + ' · ' + text : text
    }
    case 'trial_booked':
      return 'Записан на пробный — ' + ((meta && meta.date) || '') + ' ' + ((meta && meta.time) || '')
        + ', препод ' + ((meta && meta.teacherName) || '?')
    case 'task_created':
      return 'Поставлена задача: ' + ((meta && (meta.text || meta.type)) || '')
    case 'task_done':
      return 'Задача закрыта' + ((meta && meta.result) ? ' — ' + meta.result : '')
    case 'teacher_declined':
      return 'Препод ' + ((meta && meta.teacherName) || '?') + ' отказался / не ответил вовремя'
    case 'booking_verified':
      return 'Клиент сам подтвердил номер из смс'
    case 'reactivated':
      return 'Повторный обзвон после отказа — попытка ' + (meta && meta.attempt) + ' (через ' + (meta && meta.afterDays) + ' дн.)'
    default:
      return event
  }
}

function DealComments({ leadId }) {
  const [items, setItems] = useState(null)
  const [text, setText] = useState('')
  const [sending, setSending] = useState(false)
  const load = useCallback(() => {
    api.get('/api/deals/' + leadId + '/history')
      .then(r => setItems((r.data || []).filter(e => e.event === 'comment')))
      .catch(() => setItems([]))
  }, [leadId])
  useEffect(() => { load() }, [load])
  const fmt = (s) => s ? s.slice(0, 10).split('-').reverse().slice(0, 2).join('.') + ', ' + s.slice(11, 16) : ''
  const add = () => {
    const t = text.trim()
    if (!t || sending) return
    setSending(true)
    api.post('/api/deals/' + leadId + '/note', { text: t })
      .then(() => { setText(''); load() })
      .catch(e => alert('Не удалось сохранить комментарий: ' + (e.response?.data?.error || e.message)))
      .finally(() => setSending(false))
  }
  return (
    <div className="mt-2.5">
      <div className="text-[12px] font-semibold py-1" style={{ color: '#B45309' }}>💬 Комментарии{items ? ` (${items.length})` : ''}</div>
      <div className="rounded-lg overflow-hidden" style={{ border: '1px solid #FDE68A' }}>
        {items === null ? (
          <div className="text-[12.5px] text-slate-400 px-3 py-2 bg-slate-50">Загрузка…</div>
        ) : items.length === 0 ? (
          <div className="text-[12.5px] px-3 py-2" style={{ color: '#92400E', background: '#FFFBEB' }}>Пока нет комментариев</div>
        ) : items.map((it, i) => (
          <div key={it.id} className="px-3 py-2 text-[12.5px]" style={{ background: i % 2 ? '#FFFBEB' : '#FEF3C7' }}>
            <div className="flex items-baseline gap-2">
              <span className="text-slate-600 font-semibold">{it.managerName || 'Система'}</span>
              <span className="text-slate-400" style={{ fontVariantNumeric: 'tabular-nums' }}>{fmt(it.at)}</span>
            </div>
            <div className="text-slate-700 whitespace-pre-wrap mt-0.5">{(it.meta && it.meta.text) || ''}</div>
          </div>
        ))}
      </div>
      <div className="flex gap-2 mt-1.5">
        <textarea value={text} onChange={e => setText(e.target.value)} rows={2}
          placeholder="Написать комментарий к сделке…"
          className="flex-1 border border-slate-200 rounded-lg px-2.5 py-1.5 text-[13px] outline-none focus:border-sky-400 resize-none"/>
        <button onClick={add} disabled={sending || !text.trim()}
          className="self-end text-[12px] font-bold text-white bg-amber-500 rounded-lg px-3 py-1.5 hover:bg-amber-600 disabled:opacity-50">
          {sending ? 'Сохраняю…' : 'Добавить'}
        </button>
      </div>
    </div>
  )
}

function LeadHistory({ leadId }) {
  const [open, setOpen] = useState(false)
  const [items, setItems] = useState(null)

  const toggle = () => {
    const next = !open
    setOpen(next)
    if (next && items === null) {
      api.get('/api/deals/' + leadId + '/history')
        .then(r => setItems(withPrevPrice(r.data || [])))
        .catch(() => setItems([]))
    }
  }

  const fmt = (s) => {
    if (!s) return ''
    const datePart = s.slice(0, 10).split('-').reverse().slice(0, 2).join('.')
    const timePart = s.slice(11, 16)
    return datePart + ', ' + timePart
  }

  return (
    <div className="mt-2.5">
      <div className="flex items-center gap-1.5 text-[12px] font-semibold text-slate-500 cursor-pointer select-none py-1"
           onClick={toggle}>
        <span style={{ display: 'inline-block', fontSize: 9, transition: 'transform .15s', transform: open ? 'rotate(90deg)' : 'none' }}>▶</span>
        Журнал сделки{items ? ` (${items.length})` : ''}
      </div>
      {open && (
        <div className="rounded-lg overflow-hidden border border-slate-100">
          {items === null ? (
            <div className="text-[12.5px] text-slate-400 px-3 py-2 bg-slate-50">Загрузка…</div>
          ) : items.length === 0 ? (
            <div className="text-[12.5px] text-slate-400 px-3 py-2 bg-slate-50">Пока пусто</div>
          ) : items.map((it, i) => (
            <div key={it.id} className="flex items-baseline gap-2 text-[12.5px] px-3 py-2"
                 style={{ background: i % 2 ? '#fff' : '#fafbfc' }}>
              <span className="text-slate-400 shrink-0" style={{ fontVariantNumeric: 'tabular-nums' }}>{fmt(it.at)}</span>
              <span className="text-slate-500 font-semibold shrink-0">{it.managerName || 'Система'}</span>
              <span className="text-slate-700">{formatHistoryEvent(it)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// Срок задачи всегда пишем МОСКОВСКИМ временем без часового пояса — ровно в том же
// виде, в каком его вводит менеджер в форме «Перезвонить» (дата + время). Очередь
// сравнивает срок с московским «сейчас», поэтому UTC-строка из toISOString() давала
// задачу, созревающую на 3 часа раньше срока.
function mskDueAt(ms) {
  return new Date(ms + 3 * 3600 * 1000).toISOString().slice(0, 19)
}

// ─────────── Callback form ───────────
function CallbackForm({ onClose, onSubmit }) {
  const [date, setDate] = useState(''); const [time, setTime] = useState(''); const [note, setNote] = useState('')
  return (
    <div className="rounded-2xl p-4" style={{ background: '#F0F9FF', border: '1px solid #BAE6FD' }}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: '#E0F2FE', color: '#0369A1' }}>
            <IconCalendar size={13}/>
          </span>
          <div className="text-[13px] font-semibold text-sky-800">Поставить задачу «Перезвонить»</div>
        </div>
        <button onClick={onClose} className="text-sky-700/70 hover:text-sky-900"><IconX size={14}/></button>
      </div>
      <div className="grid grid-cols-2 gap-2.5">
        <label className="block">
          <div className="text-[11px] uppercase tracking-wider text-sky-700/80 font-semibold mb-1">Дата</div>
          <input type="date" value={date} onChange={e => setDate(e.target.value)}
                 className="w-full text-[13px] bg-white border border-sky-200 rounded-lg px-3 py-2 outline-none focus:border-sky-400" />
        </label>
        <label className="block">
          <div className="text-[11px] uppercase tracking-wider text-sky-700/80 font-semibold mb-1">Время</div>
          <input type="time" value={time} onChange={e => setTime(e.target.value)}
                 className="w-full text-[13px] bg-white border border-sky-200 rounded-lg px-3 py-2 outline-none focus:border-sky-400" />
        </label>
      </div>
      <label className="block mt-2.5">
        <div className="text-[11px] uppercase tracking-wider text-sky-700/80 font-semibold mb-1">Комментарий</div>
        <textarea value={note} onChange={e => setNote(e.target.value)} rows={3}
                  className="w-full text-[13px] bg-white border border-sky-200 rounded-lg px-3 py-2 outline-none focus:border-sky-400 resize-none" />
      </label>
      <div className="flex items-center gap-3 mt-3">
        <button className="text-[13px] font-semibold text-white px-4 py-2 rounded-lg" style={{ background: '#38BDF8' }}
                onClick={() => { if (date && time) onSubmit(date, time, note) }}>
          Поставить задачу
        </button>
        <button className="text-[13px] text-sky-700/80 hover:text-sky-900" onClick={onClose}>Отмена</button>
      </div>
    </div>
  )
}

// ─────────── Reject form ───────────
// «Закончил школу» — окончательный отказ: бэкенд (routes/deals.js /move, reason) ставит
// reject_retry_count=2, и повторный обзвон через 7/14 дней такого клиента не трогает (Антон 27.08).
// «Просили не звонить» — тоже окончательный и закрывает все карточки этого телефона (Антон 22.09).
const REJECT_REASONS = ['Хотят очно', 'Дорого', 'Не берёт трубку', 'Закончил школу', 'Просили не звонить', 'Дубль', 'Другое']
function RejectForm({ onClose, onSubmit }) {
  const [selected, setSelected] = useState(null); const [custom, setCustom] = useState('')
  return (
    <div className="rounded-2xl p-4" style={{ background: '#FEF2F2', border: '1px solid #FECACA' }}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: '#FEE2E2', color: '#B91C1C' }}>
            <IconX size={13} strokeWidth={2.4}/>
          </span>
          <div className="text-[13px] font-semibold text-red-800">Причина отказа</div>
        </div>
        <button onClick={onClose} className="text-red-700/70 hover:text-red-900"><IconX size={14}/></button>
      </div>
      <div className="text-[11px] uppercase tracking-wider text-red-700/80 font-semibold mb-1.5">Быстрые причины</div>
      <div className="flex flex-wrap gap-2">
        {REJECT_REASONS.map(r => {
          const on = selected === r
          return (
            <button key={r} onClick={() => setSelected(on ? null : r)}
                    className="text-[12px] font-medium px-3 py-1.5 rounded-full transition-colors"
                    style={on
                      ? { background: '#DC2626', color: 'white', border: '1px solid #DC2626' }
                      : { background: 'white', color: '#B91C1C', border: '1px solid #FECACA' }}>
              {r}
            </button>
          )
        })}
      </div>
      <label className="block mt-3">
        <div className="text-[11px] uppercase tracking-wider text-red-700/80 font-semibold mb-1">Или введите причину вручную</div>
        <textarea rows={2} value={custom} onChange={e => setCustom(e.target.value)}
                  placeholder="Например: переехали, ребёнок сменил школу…"
                  className="w-full text-[13px] bg-white border border-red-200 rounded-lg px-3 py-2 outline-none focus:border-red-400 resize-none placeholder:text-red-900/30" />
      </label>
      <div className="flex items-center gap-3 mt-3">
        <button className="text-[13px] font-semibold text-white px-4 py-2 rounded-lg" style={{ background: '#DC2626' }}
                onClick={() => { const reason = custom || selected; if (reason) onSubmit(reason) }}>
          Подтвердить отказ
        </button>
        <button className="text-[13px] text-red-700/80 hover:text-red-900" onClick={onClose}>Отмена</button>
      </div>
    </div>
  )
}

// ─────────── Action row ───────────
function ActionRow({ open, setOpen, canTrial, trialLabel }) {
  const trialDisabled = !canTrial
  return (
    <div className="grid grid-cols-3 gap-3">
      <TrialButton label={trialLabel} disabled={trialDisabled} onClick={() => setOpen(open === 'trial' ? null : 'trial')} />
      <button onClick={() => setOpen(open === 'callback' ? null : 'callback')}
        className="h-12 rounded-xl font-semibold text-[14px] transition-colors"
        style={{ background: open === 'callback' ? '#F0F9FF' : 'white', color: '#0284C7', border: '2px solid #38BDF8' }}>
        Перезвонить
      </button>
      <button onClick={() => setOpen(open === 'reject' ? null : 'reject')}
        className="h-12 rounded-xl font-semibold text-[14px] transition-colors"
        style={{ background: '#FEF2F2', color: '#B91C1C', border: '1px solid #FECACA' }}>
        Отказ
      </button>
    </div>
  )
}


// ─────────── Deal card ───────────
const STATUS_LABEL_RU = { calling: 'обзванивается', callback: 'перезвонить', rejected: 'отказ', trial: 'пробный', duplicate: 'дубль' }

// «Клиент забронировал урок, но не подтвердил номер за 10 минут» — срочный лид
// от платформы (см. routes/deals.js POST /unverified-booking). Красный/яркий —
// самый приоритетный сигнал, звонить нужно быстро, пока клиент ещё «тёплый»
// (Антон 2026-07-20, реальный случай — Захарова Екатерина подтвердила
// несуществующий урок, т.к. клиент так и не вошёл в кабинет).
function UnverifiedBookingBanner({ deal }) {
  if (!deal.phoneUnverified) return null
  return (
    <div className="rounded-2xl p-4 mb-4" style={{ background: '#FEF2F2', border: '1.5px solid #FECACA' }}>
      <div className="flex items-center gap-2 mb-1">
        <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0"
              style={{ background: '#FECACA', color: '#B91C1C' }}>📵</span>
        <div className="text-[13px] font-bold" style={{ color: '#B91C1C' }}>
          Срочно: клиент забронировал урок, но не подтвердил номер
        </div>
      </div>
      <div className="text-[12.5px]" style={{ color: '#B91C1C', paddingLeft: 32, lineHeight: 1.5 }}>
        {deal.assignedTeacher && <>Препод: <b>{deal.assignedTeacher}</b><br /></>}
        Помогите ему войти в кабинет по коду из SMS, пока интерес свежий.
      </div>
    </div>
  )
}

// «Это уже действующий ученик платформы» — проверка НАПРЯМУЮ по реальным урокам
// (не по истории заявок в СРМ), см. buildDealExtras на бэке. Реальный случай
// 20.07: Шарков Иван Романович — заявка с сайта пришла на телефон ученика,
// который уже занимается каждую неделю, менеджер чуть не начала звонить как
// новому лиду. Зелёный (не жёлтый как дубли заявок) — это самый сильный сигнал:
// звонить не нужно, отмечать «Отказ → Дубль».
// Сколько раз по карточке уже отказывали. Роман 22.10.2026: «не надо доёбывать людей —
// если два раза отказали, убирай из базы и помечай, что было 2 отказа». Два и больше —
// карточка в обзвон уже не вернётся, но пока она на экране, звонильщик должен видеть,
// с чем звонит (кейс 9439: дважды «заявку не оставляли», а человека набрали в третий раз).
function RefusedBeforeBanner({ count, reasons }) {
  if (!count) return null
  const many = count >= 2
  const word = count === 1 ? 'отказ' : count < 5 ? 'отказа' : 'отказов'
  return (
    <div className="rounded-2xl p-4 mb-4"
         style={{ background: many ? '#FEF2F2' : '#FFFBEB', border: '1px solid ' + (many ? '#FECACA' : '#FDE68A') }}>
      <div className="flex items-center gap-2">
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full"
              style={{ background: many ? '#FECACA' : '#FDE68A', color: many ? '#B91C1C' : '#92400E' }}>⛔</span>
        <div className="text-[13px] font-bold" style={{ color: many ? '#B91C1C' : '#92400E' }}>
          По этой карточке уже {count} {word}
        </div>
      </div>
      {reasons && reasons.length > 0 && (
        <div className="mt-1 text-[12.5px]" style={{ color: many ? '#DC2626' : '#B45309', paddingLeft: 32 }}>
          Причины: {reasons.join(' · ')}
        </div>
      )}
      {many && (
        <div className="mt-1 text-[12.5px]" style={{ color: '#DC2626', paddingLeft: 32 }}>
          Человеку уже дважды сказали «нет» — в обзвон карточка больше не вернётся. Звонить третий раз не нужно.
        </div>
      )}
    </div>
  )
}

function ActiveStudentBanner({ activeStudent }) {
  if (!activeStudent) return null
  return (
    <div className="rounded-2xl p-4 mb-4" style={{ background: '#ECFDF5', border: '1px solid #A7F3D0' }}>
      <div className="flex items-center gap-2">
        <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0"
              style={{ background: '#A7F3D0', color: '#047857' }}>🎓</span>
        <div className="text-[13px] font-bold" style={{ color: '#047857' }}>
          Уже занимается у нас{activeStudent.teacherName ? ` — препод ${activeStudent.teacherName}` : ''}
        </div>
      </div>
      <div className="text-[12.5px] mt-1" style={{ color: '#059669', paddingLeft: 32 }}>
        Это не новый лид — звонить не нужно. Отметьте «Отказ» → причина «Дубль».
      </div>
    </div>
  )
}

// Пометка «уже занимались этим клиентом» — если по тому же телефону есть другие
// лиды (обычно дубль с сайта, см. 11.07: два менеджера получили одну заявку
// как два разных лида). Показывает прошёл ли пробный / поставлен ли / просто отказ.
function DuplicateHistoryBanner({ history }) {
  if (!history || history.length === 0) return null
  const now = new Date()
  return (
    <div className="rounded-2xl p-4 mb-4" style={{ background: '#FFF7ED', border: '1px solid #FDE68A' }}>
      <div className="flex items-center gap-2 mb-2">
        <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0"
              style={{ background: '#FDE68A', color: '#B45309' }}>⚠️</span>
        <div className="text-[13px] font-bold text-amber-900">Уже есть заявки с этого телефона</div>
      </div>
      <div className="flex flex-col gap-1.5">
        {history.map(h => {
          let line
          if (h.trial) {
            const trialAt = new Date(`${h.trial.date}T${h.trial.time}:00+03:00`)
            const passed = trialAt < now
            line = `${passed ? 'Пробный прошёл' : 'Пробный поставлен на'} ${h.trial.date} в ${h.trial.time}, препод ${h.trial.teacherName}`
          } else if (h.status === 'rejected') {
            line = 'Отказ'
          } else {
            line = 'Занимались (' + (STATUS_LABEL_RU[h.status] || h.status) + ')'
          }
          return (
            <div key={h.leadId} className="text-[13px] text-amber-900">
              <span className="font-semibold">#{h.leadId}</span> — {line}
              {h.managerName ? <span className="text-amber-700"> · {h.managerName}</span> : null}
            </div>
          )
        })}
      </div>
    </div>
  )
}

function DealCard({
  deal, tasks, values, onUpdate, onUpdateMany, saveStatus, onRecall, onReject, onTrial, onCompleteTask, onNextClient,
  extraChildren, activeChildIdx, onSwitchChild, onAddChild, onRemoveChild, onUpdateChild, onBirzhaCreated,
  onPullOldMk, pulling = false, pullMsg = null,
}) {
  const [openForm, setOpenForm] = useState(null)
  const [bookedTrials, setBookedTrials] = useState([])
  // Пустая очередь объясняет себя сама: смена выключена / лимит базы / нет живых
  // заявок / база кончилась (Роман 22.10.2026 — «каждый день одно и то же»).
  const [emptyWhy, setEmptyWhy] = useState(null)
  useEffect(() => {
    if (deal) { setEmptyWhy(null); return }
    let alive = true
    api.get('/api/deals/empty-reason')
      .then(r => { if (alive) setEmptyWhy(r.data || null) })
      .catch(() => { if (alive) setEmptyWhy(null) })
    return () => { alive = false }
  }, [deal])

  if (!deal) {
    const TONE = {
      stop: { bg: '#FEF2F2', br: '#FECACA', fg: '#B91C1C' },
      warn: { bg: '#FFFBEB', br: '#FDE68A', fg: '#92400E' },
      info: { bg: '#F8FAFC', br: '#E2E8F0', fg: '#334155' },
    }
    const reasons = (emptyWhy && emptyWhy.reasons) || []
    return (
      <div className="rounded-2xl p-8 bg-white text-center" style={{ border: '2px solid #38BDF8' }}>
        <div className="text-slate-400 text-[15px]">Нет активных сделок в очереди</div>
        {reasons.length > 0 && (
          <div className="mt-5 mx-auto flex max-w-[580px] flex-col gap-2 text-left">
            {reasons.map(r => {
              const t = TONE[r.level] || TONE.info
              return (
                <div key={r.key} className="rounded-lg px-3 py-2" style={{ background: t.bg, border: '1px solid ' + t.br }}>
                  <div className="text-[13px] font-semibold" style={{ color: t.fg }}>{r.text}</div>
                  {r.hint && <div className="mt-0.5 text-[12px] text-slate-500">{r.hint}</div>}
                </div>
              )
            })}
          </div>
        )}
      </div>
    )
  }

  const status = tagToStatus(deal.tag)
  const task = tasks && tasks[0]
  const activeExtra = activeChildIdx > 0 ? (extraChildren || [])[activeChildIdx - 1] : null
  const activeChildValues = activeExtra || values
  const done = activeExtra ? countRequiredForChild(values, activeChildValues) : countRequired(values)
  const total = requiredTotalFor(activeChildValues)
  const canTrial = done >= total

  const handleRecall = (date, time, note) => { onRecall(date, time, note); setOpenForm(null) }
  const handleReject = (reason) => { onReject(reason); setOpenForm(null) }
  const handleTrial = async (params) => {
    setOpenForm(null)
    const result = await onTrial({ ...params, childId: activeExtra ? activeExtra.id : null })
    if (result) {
      // Плитка «Мои пробные» и карточка плана слушают это событие — цифра
      // прибавляется сразу, не дожидаясь перезагрузки страницы.
      window.dispatchEvent(new Event('plan-refresh'))
      setBookedTrials(prev => [...prev, {
        subject: params.subject, date: params.date, time: params.time,
        teacherName: params.teacherName,
        childLabel: activeExtra ? (activeExtra.childName || `Ребёнок ${activeChildIdx + 1}`) : null,
        // id брони + телефон — для кнопки «Отправить SMS со ссылкой» (09.09.2026)
        bookingId: (result.booking && result.booking.id) || null,
        phone: deal.phone || null,
      }])
    }
  }

  const title = deal.parentName
    ? deal.parentName + ' (родитель)'
    : deal.childName ? deal.childName + ' (ребёнок)' : 'Сделка'

  return (
    <div className="rounded-2xl p-5 bg-white flex flex-col" style={{ border: '2px solid #38BDF8' }}>
      <UnverifiedBookingBanner deal={deal} />
      <RefusedBeforeBanner count={deal.refuseCount} reasons={deal.refuseReasons} />
      <ActiveStudentBanner activeStudent={deal.activeStudent} />
      <DuplicateHistoryBanner history={deal.duplicateHistory} />
      <div className="flex items-start justify-between gap-4 pb-4 mb-4 border-b border-slate-100">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <IconUser size={14} className="text-slate-400"/>
            <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold">Клиент</div>
          </div>
          <div className="flex items-center gap-3 flex-wrap mt-1">
            <div className="text-[22px] font-semibold tracking-tight text-slate-900">{title} · #{deal.id}</div>
          </div>
          <div className="text-[12px] text-slate-500 mt-0.5 font-mono">{deal.name || 'без названия'}</div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <StatusBadge status={status} batchName={deal.batchName} sourceLabel={deal.sourceLabel} />
          <button onClick={() => setOpenForm('birzha')}
            className="h-9 px-3.5 rounded-xl font-semibold text-[13px] transition-colors"
            style={{ background: '#F0F9FF', color: '#0369A1', border: '1px solid #BAE6FD' }}
            title="Отдать ученика преподавателям на биржу">
            Отдать на биржу
          </button>
        </div>
      </div>

      <ClientBlock values={values} onUpdate={onUpdate} onUpdateMany={onUpdateMany} saveStatus={saveStatus}
        extraChildren={extraChildren} activeChildIdx={activeChildIdx} onSwitchChild={onSwitchChild}
        onAddChild={onAddChild} onRemoveChild={onRemoveChild} onUpdateChild={onUpdateChild} />

      {deal.batchName && (
        <div className="mb-4 flex items-center gap-3 flex-wrap">
          <button type="button" onClick={onPullOldMk} disabled={pulling}
            className="px-3.5 py-2 rounded-lg border border-slate-200 bg-white text-slate-600 text-[12.5px] font-semibold hover:bg-slate-50"
            title={PULL_OLDMK_TITLE}>
            {pulling ? '…' : PULL_OLDMK_LABEL}
          </button>
          {pullMsg ? <span className="text-[12px] text-slate-500">{pullMsg}</span> : null}
        </div>
      )}
      <div className="mt-4 flex flex-col gap-3 [&>*]:my-0">
      <TaskBlock task={task} onComplete={onCompleteTask} />
      {deal.batchName && deal.comment ? (
        <div className="mb-4 rounded-xl px-4 py-3 text-[12.5px] leading-relaxed whitespace-pre-wrap"
          style={{ background: '#EFF6FF', color: '#1E40AF', border: '1px solid #BFDBFE' }}>
          <b>Занималась у нас раньше:</b> {deal.comment}
        </div>
      ) : null}

      <TaskHistory leadId={deal.id} />
      <DealComments leadId={deal.id} />
      <LeadHistory leadId={deal.id} />
      </div>

      {openForm && openForm !== 'trial' && (
        <div className="mt-4">
          {openForm === 'callback' && <CallbackForm onClose={() => setOpenForm(null)} onSubmit={handleRecall} />}
          {openForm === 'reject'   && <RejectForm   onClose={() => setOpenForm(null)} onSubmit={handleReject} />}
        </div>
      )}

      <div className="space-y-2.5 mt-4">
        <BookedTrialsList items={bookedTrials} />

        {/* Со скидкой (от 800/900/1000) запись пойдёт только на платформенного препода,
            а у платформенных пробных нет — кнопка честно называется «Записать на урок». */}
        <ActionRow open={openForm} setOpen={setOpenForm} canTrial={canTrial}
          trialLabel={trialButtonLabel(activeChildValues.priceOverride, activeChildValues.classNum)} />

        {bookedTrials.length > 0 && (
          <button onClick={onNextClient}
            className="w-full h-11 rounded-xl font-semibold text-[13.5px]"
            style={{ background: '#F8FAFC', color: '#64748B', border: '1px solid #E2E8F0' }}>
            Готово, следующий клиент →
          </button>
        )}
      </div>

      <BirzhaModal
        open={openForm === 'birzha'}
        onClose={() => setOpenForm(null)}
        dealId={deal.id}
        clientLabel={`${activeChildValues.childName || title} · ${activeChildValues.subject || '—'} · #${deal.id}`}
        initial={{ subject: activeChildValues.subject, classNum: activeChildValues.classNum,
                   childName: activeChildValues.childName }}
        onCreated={() => { if (typeof onBirzhaCreated === 'function') onBirzhaCreated() }}
      />

      <TrialSignupModal
        open={openForm === 'trial'}
        onClose={() => setOpenForm(null)}
        clientLabel={`${activeChildValues.childName || title} · ${activeChildValues.subject || '—'} · #${deal.id}`}
        initial={{ ...activeChildValues, priceOverride: activeChildValues.priceOverride, priceOverrideAge: activeChildValues.priceOverrideAge }}
        onSubmit={handleTrial}
      />
    </div>
  )
}

// ─────────── Calls blocks (unchanged logic) ───────────
function AudioMock({ duration }) {
  const [playing, setPlaying] = useState(false); const [pos, setPos] = useState(8)
  useEffect(() => {
    if (!playing) return
    const t = setInterval(() => setPos(p => (p >= 100 ? 100 : p + 0.6)), 100)
    return () => clearInterval(t)
  }, [playing])
  const [m, s] = duration.split(':').map(Number); const total = m * 60 + s
  const cur = Math.floor((pos / 100) * total)
  const fmt = (v) => `${Math.floor(v/60)}:${String(v%60).padStart(2,'0')}`
  return (
    <div className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-xl px-3 py-2.5">
      <button onClick={() => setPlaying(p => !p)}
              className="w-9 h-9 rounded-full flex items-center justify-center text-white" style={{ background: '#38BDF8' }}>
        {playing ? <IconPause size={14}/> : <IconPlay size={14}/>}
      </button>
      <div className="flex-1">
        <div className="relative h-1.5 bg-slate-200 rounded-full overflow-hidden">
          <div className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${pos}%`, background: '#38BDF8' }} />
        </div>
        <div className="flex justify-between mt-1.5 text-[11px] font-mono text-slate-500">
          <span>{fmt(cur)}</span><span>{duration}</span>
        </div>
      </div>
    </div>
  )
}
function Checklist({ items }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1.5">
      {items.map((it, i) => (
        <div key={i} className="flex items-center gap-2 text-[13px]">
          <span className="w-4 h-4 rounded-full flex items-center justify-center shrink-0"
                style={{ background: it.ok ? '#DCFCE7' : '#FEE2E2', color: it.ok ? '#15803D' : '#B91C1C' }}>
            {it.ok ? <IconCheck size={10} strokeWidth={2.5}/> : <IconX size={10} strokeWidth={2.5}/>}
          </span>
          <span className={it.ok ? 'text-slate-700' : 'text-slate-500 line-through'}>{it.label}</span>
        </div>
      ))}
    </div>
  )
}
function Dialog({ turns }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white divide-y divide-slate-100">
      {turns.map((t, i) => {
        const mgr = t.who === 'manager'
        return (
          <div key={i} className="px-3.5 py-2.5 flex gap-3">
            <div className="w-[88px] shrink-0">
              <div className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full" style={{ background: mgr ? '#38BDF8' : '#FBBF24' }} />
                <span className="text-[11px] font-semibold uppercase tracking-wide" style={{ color: mgr ? '#0369A1' : '#92400E' }}>
                  {mgr ? 'Менеджер' : 'Клиент'}
                </span>
              </div>
            </div>
            <div className="text-[13px] text-slate-700 leading-relaxed flex-1">{t.text}</div>
          </div>
        )
      })}
    </div>
  )
}
function CallCard({ call, defaultOpen }) {
  const [open, setOpen] = useState(!!defaultOpen)
  const sc = scoreColor(call.score); const isIn = call.direction === 'in'
  const okCount = call.checklist.filter(c => c.ok).length
  return (
    <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
      <button onClick={() => setOpen(o => !o)}
              className="w-full flex items-center gap-4 px-4 py-3 hover:bg-slate-50/60 transition-colors text-left">
        <IconChevron size={14} className={`text-slate-400 transition-transform ${open ? 'rotate-90' : ''}`} />
        <div className="flex items-center gap-2 min-w-[200px]">
          <span className="w-7 h-7 rounded-full flex items-center justify-center"
                style={{ background: isIn ? '#ECFEFF' : '#FFF7ED', color: isIn ? '#0E7490' : '#B45309' }}>
            {isIn ? <IconPhoneIn size={13}/> : <IconPhoneOut size={13}/>}
          </span>
          <div className="leading-tight">
            <div className="text-[13px] font-medium text-slate-800">{isIn ? 'Входящий' : 'Исходящий'}</div>
            <div className="text-[11px] text-slate-500">{call.date} · {call.duration}</div>
          </div>
        </div>
        <div className="flex items-center gap-3 flex-1">
          <div className="text-[11px] uppercase tracking-wider text-slate-400 font-medium">Оценка скрипта</div>
          <div className="flex items-baseline gap-1">
            <span className="text-2xl font-semibold" style={{ color: sc.text }}>{call.score}</span>
            <span className="text-xs text-slate-400">/ 10</span>
          </div>
          <span className="text-[11px] font-medium px-2 py-0.5 rounded-full"
                style={{ background: sc.bg, color: sc.text, border: `1px solid ${sc.ring}` }}>
            <span className="inline-block w-1.5 h-1.5 rounded-full align-middle mr-1" style={{ background: sc.dot }} />
            {sc.label}
          </span>
          <div className="text-[11px] text-slate-500 hidden md:block">чек-лист {okCount}/{call.checklist.length}</div>
        </div>
      </button>
      {open && (
        <div className="px-4 pb-4 pt-1 border-t border-slate-100 space-y-4">
          <AudioMock duration={call.duration} />
          <div className="grid grid-cols-1 lg:grid-cols-[1.35fr_1fr] gap-4">
            <div>
              <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mb-2">Диалог</div>
              <Dialog turns={call.dialog} />
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mb-2">Чек-лист скрипта</div>
              <div className="rounded-xl border border-slate-200 bg-white p-3.5">
                <Checklist items={call.checklist} />
              </div>
            </div>
          </div>
          {call.recommendation && (
            <div className="rounded-xl p-3.5 flex gap-3" style={{ background: '#F0F9FF', border: '1px solid #BAE6FD' }}>
              <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0" style={{ background: '#E0F2FE', color: '#0369A1' }}>
                <IconBulb size={13}/>
              </span>
              <div>
                <div className="text-[11px] uppercase tracking-wider font-semibold" style={{ color: '#0369A1' }}>Рекомендация</div>
                <div className="text-[13px] text-slate-700 leading-relaxed mt-0.5">{call.recommendation}</div>
              </div>
            </div>
          )}
          {call.problems && (
            <div className="rounded-xl p-3.5 flex gap-3" style={{ background: '#FEF2F2', border: '1px solid #FECACA' }}>
              <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0" style={{ background: '#FEE2E2', color: '#B91C1C' }}>
                <IconAlert size={13}/>
              </span>
              <div>
                <div className="text-[11px] uppercase tracking-wider font-semibold" style={{ color: '#B91C1C' }}>Проблемы</div>
                <div className="text-[13px] text-slate-700 leading-relaxed mt-0.5">{call.problems}</div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
function CompactCallRow({ call, onOpen }) {
  const sc = scoreColor(call.score); const isIn = call.direction === 'in'
  const okCount = call.checklist.filter(c => c.ok).length
  return (
    <button onClick={onOpen}
      className="w-full text-left rounded-xl border border-slate-200 bg-white hover:border-sky-300 hover:bg-sky-50/30 transition-colors p-2.5">
      <div className="flex items-center gap-2">
        <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0"
              style={{ background: isIn ? '#ECFEFF' : '#FFF7ED', color: isIn ? '#0E7490' : '#B45309' }}>
          {isIn ? <IconPhoneIn size={11}/> : <IconPhoneOut size={11}/>}
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-[11px] font-medium text-slate-700 truncate">{isIn ? 'Входящий' : 'Исходящий'} · {call.duration}</div>
          <div className="text-[10px] text-slate-500 truncate font-mono">{call.date}</div>
        </div>
        <div className="flex items-baseline gap-0.5 shrink-0" style={{ color: sc.text }}>
          <span className="text-[16px] font-semibold leading-none">{call.score}</span>
          <span className="text-[10px] text-slate-400">/10</span>
        </div>
      </div>
      <div className="mt-2 flex items-center gap-1.5">
        <div className="flex-1 h-1 rounded-full bg-slate-100 overflow-hidden">
          <div className="h-full" style={{ width: `${(call.score / 10) * 100}%`, background: sc.dot }} />
        </div>
        <div className="text-[10px] font-mono text-slate-400 shrink-0">{okCount}/{call.checklist.length}</div>
      </div>
    </button>
  )
}
function CallDetailModal({ call, onClose }) {
  if (!call) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6" style={{ background: 'rgba(15,23,42,0.45)' }} onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-[920px] w-full max-h-[88vh] overflow-auto" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 z-10 bg-white/95 backdrop-blur border-b border-slate-100 px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <IconSparkle size={14} className="text-sky-500"/>
            <div className="text-[14px] font-semibold text-slate-900">Анализ звонка</div>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-slate-100 flex items-center justify-center text-slate-500">
            <IconX size={14}/>
          </button>
        </div>
        <div className="p-4"><CallCard call={call} defaultOpen /></div>
      </div>
    </div>
  )
}
function NextCallsCard({ calls, analyzing, onAnalyze, phone }) {
  const [openCall, setOpenCall] = useState(null)
  return (
    <>
      <div className="rounded-2xl bg-white border border-slate-200 p-4">
        <div className="flex items-center justify-between">
          <div className="text-[13px] font-semibold text-slate-900">Последние звонки</div>
          <span className="text-[11px] text-slate-500 bg-slate-100 px-1.5 py-0.5 rounded-full">{calls.length}</span>
        </div>
        <div className="mt-1 flex items-center gap-1.5 text-[10px] text-slate-500">
          <IconSparkle size={10} className="text-sky-500"/>
          <span>Автоматический разбор по скрипту</span>
        </div>
        <button onClick={onAnalyze} disabled={analyzing || !phone}
          className="mt-3 w-full text-[12px] font-semibold py-2 rounded-lg transition-colors flex items-center justify-center gap-2"
          style={{
            background: analyzing ? '#F0F9FF' : '#38BDF8',
            color: analyzing ? '#0369A1' : 'white',
            border: analyzing ? '1px solid #BAE6FD' : 'none',
            opacity: !phone ? 0.5 : 1,
            cursor: (!phone || analyzing) ? 'default' : 'pointer'
          }}>
          {analyzing ? (
            <>
              <span className="inline-block w-3 h-3 rounded-full border-2 border-sky-600 border-t-transparent animate-spin" />
              Анализирую звонок...
            </>
          ) : (<><IconSparkle size={12}/>Анализировать последний звонок</>)}
        </button>
        {!phone && <div className="mt-2 text-[10px] text-slate-400 text-center">Телефон клиента не найден</div>}
        <div className="mt-3 space-y-2">
          {calls.length === 0 ? (
            <div className="rounded-xl border border-dashed border-slate-200 py-6 text-center text-[11px] text-slate-400">
              {analyzing ? 'Ждём результат...' : 'Звонков пока нет'}
            </div>
          ) : calls.map(c => <CompactCallRow key={c.id} call={c} onOpen={() => setOpenCall(c)} />)}
        </div>
      </div>
      <CallDetailModal call={openCall} onClose={() => setOpenCall(null)} />
    </>
  )
}

// ─────────── Ranking ───────────
function ManagersRanking({ ranking, currentName }) {
  const [mode, setMode] = useState('calls')
  const [range, setRange] = useState('today')
  if (!ranking) return (
    <div className="rounded-2xl bg-white border border-slate-200 p-4">
      <div className="text-[13px] font-semibold text-slate-900">Рейтинг менеджеров</div>
      <div className="text-[11px] text-slate-400 text-center py-6">Загрузка…</div>
    </div>
  )
  const list = ranking[mode][range] || []
  const valueKey = mode === 'calls' ? 'calls' : 'trials'
  const numericList = list.filter(m => m[valueKey] !== null && m[valueKey] !== undefined)
  const max = Math.max(1, ...numericList.map(m => m[valueKey] || 0))
  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[13px] font-semibold text-slate-900">Рейтинг</div>
      </div>
      <div className="p-0.5 bg-slate-100 rounded-lg flex text-[12px] font-medium">
        {[{ id: 'calls', label: 'Звонки' }, { id: 'trials', label: 'Пробные' }].map(t => (
          <button key={t.id} onClick={() => setMode(t.id)}
                  className="flex-1 py-1.5 rounded-md transition-colors"
                  style={mode === t.id
                    ? { background: 'white', color: '#0F172A', boxShadow: '0 1px 2px rgba(15,23,42,0.06)' }
                    : { background: 'transparent', color: '#64748B' }}>
            {t.label}
          </button>
        ))}
      </div>
      <div className="mt-2 flex gap-1 text-[11px]">
        {[{ id: 'today', label: 'Сегодня' }, { id: 'week', label: 'Неделя' }].map(t => (
          <button key={t.id} onClick={() => setRange(t.id)}
                  className="px-2.5 py-1 rounded-full transition-colors"
                  style={range === t.id
                    ? { background: '#38BDF8', color: 'white', border: '1px solid #38BDF8' }
                    : { background: 'white', color: '#64748B', border: '1px solid #E2E8F0' }}>
            {t.label}
          </button>
        ))}
      </div>
      <div className="mt-3 space-y-2.5">
        {list.map((m, i) => {
          const isLeader = i === 0 && m[valueKey] > 0
          const isMe = currentName && m.name === currentName
          const val = m[valueKey]
          const isDash = val === null || val === undefined
          return (
            <div key={m.name} className="flex items-center gap-2.5">
              <div className="relative shrink-0">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-semibold text-white"
                     style={{ background: m.color, boxShadow: isMe ? '0 0 0 2px white, 0 0 0 3.5px #38BDF8' : 'none' }}>
                  {m.initials}
                </div>
                {isLeader && (
                  <div className="absolute -top-2 left-1/2 -translate-x-1/2 text-amber-400"><IconCrown size={14}/></div>
                )}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-baseline justify-between gap-1">
                  <div className={`text-[12px] truncate ${isMe ? 'font-semibold text-slate-900' : 'font-medium text-slate-800'}`}>
                    {m.short || m.name}
                  </div>
                  <div className="text-[12px] font-semibold shrink-0" style={{ color: isDash ? '#94A3B8' : '#0F172A' }}>
                    {isDash ? '—' : val}
                  </div>
                </div>
                <div className="mt-1 h-1 rounded-full bg-slate-100 overflow-hidden">
                  <div className="h-full rounded-full" style={{ width: isDash ? '0%' : `${((val || 0) / max) * 100}%`, background: m.color }} />
                </div>
                {isDash && mode === 'calls' && (
                  <div className="text-[9px] text-slate-400 mt-0.5">нет в Билайне</div>
                )}
              </div>
            </div>
          )
        })}
      </div>
      <div className="mt-3 pt-3 border-t border-slate-100 text-[10px] text-slate-400 font-mono">
        {mode === 'calls' ? 'звонки · ' : 'пробные · '}
        {range === 'today' ? 'сегодня' : 'неделя'}
      </div>
    </div>
  )
}

// ─────────── План звонильщиков (KPI — звонки) ───────────
const PLAN_PERIOD_LABEL = { day: 'День', week: 'Неделя', month: 'Месяц' }

function PlanBar({ label, value, target, tone }) {
  const pct = target > 0 ? Math.min(100, Math.round((value / target) * 100)) : 0
  const done = target > 0 && value >= target
  const barColor = done ? '#10B981' : (tone === 'team' ? '#A78BFA' : '#38BDF8')
  return (
    <div className="mt-3 first:mt-0">
      <div className="flex items-baseline justify-between text-[11.5px]">
        <span className="text-slate-500 font-medium">{label}</span>
        <span className="font-bold text-slate-900">{value} <span className="font-medium text-slate-400">/ {target}</span></span>
      </div>
      <div className="mt-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full rounded-full" style={{ width: pct + '%', background: barColor }} />
      </div>
    </div>
  )
}

// Цифры плана (/api/plan) для плитки и карточки. Раньше каждая читала их один раз
// при монтировании: записала пробный — число не менялось до F5, и звонильщица
// считала, что пробные не считаются (Роман 03.11.2026). Теперь обновляем сразу
// после записи (событие 'plan-refresh'), при возврате на вкладку и раз в минуту.
function usePlanData() {
  const [data, setData] = useState(null)
  useEffect(() => {
    let alive = true
    const load = () => { api.get('/api/plan').then(r => { if (alive) setData(r.data) }).catch(() => {}) }
    load()
    const onVisible = () => { if (document.visibilityState !== 'hidden') load() }
    window.addEventListener('plan-refresh', load)
    window.addEventListener('focus', onVisible)
    document.addEventListener('visibilitychange', onVisible)
    const timer = setInterval(load, 60000)
    return () => {
      alive = false
      clearInterval(timer)
      window.removeEventListener('plan-refresh', load)
      window.removeEventListener('focus', onVisible)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [])
  return data
}

// «Мои пробные N из M» рядом с вкладками (Роман 22.10.2026). Цифры те же, что в
// карточке плана: факт по этому менеджеру и цель из /api/plan (день/неделя/месяц).
function MyTrialsStat() {
  const data = usePlanData()
  const [period, setPeriod] = useState('day')
  const mine = data?.mine?.[period] ?? 0
  const target = data?.target?.[period]?.mine ?? 0
  const done = target > 0 && mine >= target
  return (
    <div className="flex items-center gap-2.5 rounded-xl bg-white px-3 py-1.5" style={{ border: '1px solid #E4E7EC' }}>
      <div className="text-[12px] font-semibold text-slate-500">Мои пробные</div>
      <div className="text-[15px] font-bold tabular-nums" style={{ color: done ? '#047857' : '#0F172A' }}>
        {mine}<span className="text-[12px] font-semibold text-slate-400"> из {target || '—'}</span>
      </div>
      <div className="flex gap-0.5 rounded-lg bg-slate-100 p-0.5">
        {[['day', 'день'], ['week', 'неделя'], ['month', 'месяц']].map(([k, label]) => (
          <button key={k} onClick={() => setPeriod(k)}
            className="rounded-md px-2 py-1 text-[10.5px] font-semibold transition-colors"
            style={period === k ? { background: 'white', color: '#0F172A', boxShadow: '0 1px 2px rgba(15,23,42,.1)' } : { color: '#64748B' }}>
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}

function PlanCard() {
  const data = usePlanData()
  const [period, setPeriod] = useState('day')

  // План с 03.08 — только ПРОБНЫЕ (звонки из плана убраны). Директор задаёт,
  // сколько пробных в день записывает каждый; недельная и месячная цель считаются
  // от этого на сервере (см. routes/plan.js).
  const p = period
  const target = data?.target?.[p] || { mine: 0, team: 0 }
  const mine = data?.mine?.[p] ?? 0
  const team = data?.teamFact?.[p] ?? 0

  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-4">
      <div className="flex items-center justify-between mb-1">
        <div className="text-[13px] font-semibold text-slate-900">План — пробные</div>
        <div className="flex gap-0.5 p-0.5 bg-slate-100 rounded-lg">
          {['day', 'week', 'month'].map(k => (
            <button key={k} onClick={() => setPeriod(k)}
              className="text-[10.5px] font-semibold px-2 py-1 rounded-md transition-colors"
              style={period === k ? { background: 'white', color: '#0F172A', boxShadow: '0 1px 2px rgba(15,23,42,.1)' } : { color: '#64748B' }}>
              {PLAN_PERIOD_LABEL[k]}
            </button>
          ))}
        </div>
      </div>
      {!data ? (
        <div className="py-8 text-center text-[12px] text-slate-400">Загрузка…</div>
      ) : (
        <>
          <PlanBar label="Мои пробные" value={mine} target={target.mine} tone="mine" />
          <PlanBar label="Пробные команды" value={team} target={target.team} tone="team" />
          <div className="mt-3 text-[11px] text-slate-400 leading-snug">
            Цель — {data.plan?.trialsPerDay ?? 0} пробных в день. Премия начисляется за пробный,
            после которого клиент встал в расписание.
          </div>
        </>
      )}
    </div>
  )
}

// ─────────── Right column ───────────
// Чат MAX в правой колонке — пока заглушка на месте бывших виджетов плана и рейтинга
// (Роман 22.10.2026). Бот тут будет НЕ тот же, что у сопроводителя: позже прикрутим
// авторизацию своего номера MAX, чтобы звонильщик писал клиенту первым после записи.
// Разметка повторяет панель чатов сопроводителя (шапка, поиск, лента, поле ввода),
// чтобы потом вставить рабочую логику без переделки вида.
// Чат MAX/Telegram в кабинете звонильщика. Логика — приложение Рината на том же
// домене (/inbox-test, FastAPI на 127.0.0.1:8766): личные аккаунты сотрудника через
// telethon (Telegram) и pymax (MAX), умеет писать первым по номеру телефона.
// Токен берём тот же, что у CRM (общий JWT), мутации требуют заголовок X-Inbox-Request.
// ВАЖНО: роль caller в ALLOWED_ROLES приложения пока не входит — до этого панель
// честно показывает «доступ не открыт», а не молчит (Роман 22.10.2026).
const INBOX = '/inbox-test/api'
async function inboxApi(path, body) {
  const token = localStorage.getItem('token') || ''
  const r = await fetch(INBOX + path, {
    method: body === undefined ? 'GET' : 'POST',
    headers: Object.assign(
      body === undefined ? {} : { 'Content-Type': 'application/json', 'X-Inbox-Request': '1' },
      token ? { Authorization: 'Bearer ' + token } : {}),
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const data = await r.json().catch(() => ({}))
  if (!r.ok) {
    // FastAPI на 422 кладёт в detail массив объектов — без разбора он печатался
    // как «[object Object]» (Роман 23.10.2026).
    const d = data.detail
    const text = typeof d === 'string' ? d
      : Array.isArray(d) ? d.map(x => (x && (x.msg || x.message)) || '').filter(Boolean).join('; ')
      : (d && (d.msg || d.message)) || ('Ошибка ' + r.status)
    const e = new Error(text || ('Ошибка ' + r.status)); e.status = r.status; throw e
  }
  return data
}
const inboxTime = (ms) => {
  const d = new Date(ms); const now = new Date()
  return d.toDateString() === now.toDateString()
    ? d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' })
}

// Окно чата MAX/Telegram — как у сопроводителя: широкое, с историей, подгрузкой
// ранних сообщений, вложениями и отправкой (Роман 22.10.2026: «в панели неудобно»).
function MaxAttachment({ dialog, message, att }) {
  const [url, setUrl] = useState(null)
  const [err, setErr] = useState(false)
  const [text, setText] = useState(null)
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    let alive = true, made = null
    const token = localStorage.getItem('token') || ''
    fetch(`${INBOX}/accounts/${dialog.account_id}/chats/${dialog.id}/messages/${message.id}/attachments/${att.index}`,
      { headers: token ? { Authorization: 'Bearer ' + token } : {} })
      .then(r => { if (!r.ok) throw new Error('attachment'); return r.blob() })
      .then(b => { if (!alive) return; made = URL.createObjectURL(b); setUrl(made) })
      .catch(() => { if (alive) setErr(true) })
    return () => { alive = false; if (made) URL.revokeObjectURL(made) }
  }, [dialog, message, att])

  const name = att.name || att.filename || 'файл'
  const type = String(att.type || att.mime || '')
  const isImage = type.startsWith('image') || /\.(jpe?g|png|gif|webp|heic)$/i.test(name)
  const isAudio = type.startsWith('audio') || /\.(ogg|oga|opus|mp3|m4a|wav)$/i.test(name)
  const isVideo = type.startsWith('video') || /\.(mp4|mov|webm)$/i.test(name)

  // Распознавание голосового — наш whisper на сервере (та же очередь, что у MAX-бота)
  const recognize = () => {
    if (!url || busy) return
    setBusy(true)
    fetch(url).then(r => r.blob()).then(b => {
      const fd = new FormData()
      fd.append('audio', b, name)
      const token = localStorage.getItem('token') || ''
      return fetch('/api/max/transcribe-upload', {
        method: 'POST', body: fd,
        headers: token ? { Authorization: 'Bearer ' + token } : {},
      })
    })
      .then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.error || 'ошибка'); return d })
      .then(d => setText(d.text || '(тишина)'))
      .catch(e => setText('Не распозналось: ' + e.message))
      .finally(() => setBusy(false))
  }

  if (err) return <div className="mt-1 text-[11px] text-rose-600">Вложение не открылось</div>
  if (!url) return <div className="mt-1 text-[11px] text-slate-400">Загружается вложение…</div>
  if (isImage) return <a href={url} target="_blank" rel="noreferrer"><img src={url} alt={name} className="mt-1 max-h-[240px] rounded-lg" /></a>
  if (isVideo) return <video src={url} controls className="mt-1 max-h-[240px] w-full rounded-lg" />
  if (isAudio) return (
    <div className="mt-1">
      <audio src={url} controls className="h-9 w-full" />
      <div className="mt-1 flex items-center gap-2">
        <button type="button" onClick={recognize} disabled={busy}
          className="rounded-md px-2 py-1 text-[11px] font-semibold disabled:opacity-50"
          style={{ background: '#EDE9FE', color: '#6D28D9' }}>
          {busy ? 'Распознаю…' : 'Распознать'}
        </button>
        <a href={url} download={name} className="text-[11px] text-slate-500 underline">скачать</a>
      </div>
      {text && <div className="mt-1 rounded-lg px-2 py-1.5 text-[12px]" style={{ background: '#F5F3FF', color: '#4C1D95' }}>{text}</div>}
    </div>
  )
  return <a href={url} download={name} className="mt-1 inline-flex items-center gap-1 text-[11.5px] font-semibold text-sky-700 underline">📎 {name}</a>
}

function MaxChatModal({ dialog, onClose }) {
  const [peerPhone, setPeerPhone] = useState(dialog.phone || '')
  const editPhone = () => {
    const v = window.prompt('Номер собеседника (+79991234567). Пустое поле — убрать номер:', peerPhone)
    if (v === null) return
    inboxApi(`/accounts/${dialog.account_id}/chats/${dialog.id}/phone`, { phone: v })
      .then(r => { setPeerPhone(r.phone || ''); dialog.phone = r.phone || '' })
      .catch(e => setErr(e.message))
  }
  const [msgs, setMsgs] = useState([])
  const [text, setText] = useState('')
  const [busy, setBusy] = useState(false)
  const [older, setOlder] = useState(false)
  const [err, setErr] = useState(null)
  const bodyRef = useRef(null)
  const atBottom = useRef(true)

  const pull = useCallback((before) => inboxApi(
    `/accounts/${dialog.account_id}/chats/${dialog.id}/messages` + (before ? '?before=' + encodeURIComponent(before) : '')
  ).then(d => (d.messages || d || []).slice().sort((a, b) => a.time - b.time)), [dialog])

  useEffect(() => {
    let alive = true
    const load = () => pull().then(rows => { if (alive) setMsgs(rows) }).catch(e => { if (alive) setErr(e.message) })
    load(); const iv = setInterval(load, 5000)
    return () => { alive = false; clearInterval(iv) }
  }, [pull])

  // Открываем чат на ПОСЛЕДНЕМ сообщении (Роман 22.10.2026). Прокручиваем и после
  // подгрузки картинок/плееров — иначе высота меняется и лента уезжает вверх.
  const firstPaint = useRef(true)
  useEffect(() => {
    const el = bodyRef.current
    if (!el || !msgs.length) return
    const toBottom = () => { el.scrollTop = el.scrollHeight }
    if (firstPaint.current || atBottom.current) {
      toBottom()
      const t1 = setTimeout(toBottom, 120)
      const t2 = setTimeout(toBottom, 600)
      const t3 = setTimeout(() => { toBottom(); firstPaint.current = false }, 1500)
      return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3) }
    }
  }, [msgs])

  const loadOlder = () => {
    if (older || !msgs.length) return
    setOlder(true)
    pull(msgs[0].id).then(rows => setMsgs(prev => {
      const seen = new Set(prev.map(m => m.id))
      return rows.filter(m => !seen.has(m.id)).concat(prev)
    })).catch(e => setErr(e.message)).finally(() => setOlder(false))
  }

  const send = () => {
    const body = text.trim()
    if (!body || busy) return
    setBusy(true); setErr(null); atBottom.current = true
    inboxApi(`/accounts/${dialog.account_id}/chats/${dialog.id}/messages`, { text: body, request_id: crypto.randomUUID() })
      .then(m => { setText(''); if (m && m.id) setMsgs(x => x.concat([m])) })
      .catch(e => setErr(e.message))
      .finally(() => setBusy(false))
  }

  const isDirector = (() => { try { return localStorage.getItem('role') === 'director' } catch { return false } })()
  const removeMsg = (m) => {
    if (!window.confirm('Удалить сообщение у всех? Это нельзя отменить.')) return
    setErr(null)
    inboxApi(`/accounts/${dialog.account_id}/chats/${dialog.id}/messages/${m.id}/delete`, {})
      .then(() => setMsgs(x => x.filter(y => y.id !== m.id)))
      .catch(e => setErr(e.message))
  }

  let lastDay = ''
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(15,23,42,0.5)' }} onClick={onClose}>
      <div className="flex h-[86vh] w-full max-w-[820px] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl" onClick={e => e.stopPropagation()}>
        <div className="flex shrink-0 items-center gap-3 border-b border-slate-200 px-5 py-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-full text-[13px] font-bold text-white"
                style={{ background: dialog.channel === 'maks' ? '#8B5CF6' : '#38BDF8' }}>
            {(dialog.title || '?').slice(0, 1).toUpperCase()}
          </span>
          <div className="min-w-0 flex-1">
            <div className="truncate text-[15px] font-semibold text-slate-900">{dialog.title}
              {peerPhone && <span className="ml-2 text-[12.5px] font-normal text-slate-500">{peerPhone}</span>}
              <button type="button" onClick={editPhone} className="ml-2 text-[11.5px] font-normal text-sky-600 hover:underline">
                {peerPhone ? 'изменить' : 'указать номер'}
              </button>
            </div>
            <div className="truncate text-[11.5px] text-slate-500">
              {dialog.channel === 'maks' ? 'MAX' : 'Telegram'} · {dialog.account_label}
              {!dialog.mine && dialog.owner_name ? ' · аккаунт: ' + dialog.owner_name : ''}
            </div>
          </div>
          <button type="button" onClick={onClose} className="text-[13px] text-slate-500 hover:text-slate-800">Закрыть</button>
        </div>

        <div ref={bodyRef} className="flex-1 overflow-auto bg-slate-50 px-5 py-3"
             onScroll={e => { const el = e.currentTarget; atBottom.current = el.scrollHeight - el.scrollTop - el.clientHeight < 60 }}>
          <div className="mb-2 text-center">
            <button type="button" onClick={loadOlder} disabled={older}
              className="rounded-full bg-white px-3 py-1 text-[11.5px] text-slate-500 shadow-sm disabled:opacity-50"
              style={{ border: '1px solid #E2E8F0' }}>
              {older ? 'Загружаем…' : 'Показать более ранние'}
            </button>
          </div>
          {msgs.length === 0 && <div className="py-8 text-center text-[12.5px] text-slate-400">Сообщений нет</div>}
          {msgs.map(m => {
            const day = new Date(m.time).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
            const sep = day !== lastDay ? (lastDay = day) : null
            return (
              <Fragment key={m.id}>
                {sep && <div className="my-2 text-center text-[11px] text-slate-400">{sep}</div>}
                <div className={'mb-2 flex ' + (m.out ? 'justify-end' : 'justify-start')}>
                  <div className="max-w-[72%] rounded-2xl px-3 py-2 text-[13px] leading-snug shadow-sm"
                       style={m.out ? { background: '#DBEAFE', color: '#0F172A' } : { background: 'white', color: '#0F172A', border: '1px solid #E2E8F0' }}>
                    {m.author_name && <div className="mb-0.5 text-[11px] font-semibold text-violet-700">Написал(а): {m.author_name}</div>}
                    {m.text && <div style={{ whiteSpace: 'pre-wrap' }}>{m.text}</div>}
                    {(m.attachments || []).map(a => (
                      <MaxAttachment key={a.index} dialog={dialog} message={m} att={a} />
                    ))}
                    {m.media && !(m.attachments || []).length && (
                      <div className="mt-1 text-[11.5px] text-slate-400">Этот тип вложения доступен в мессенджере</div>
                    )}
                    <div className="mt-0.5 flex items-center justify-end gap-2 text-[10.5px] text-slate-400">
                      {m.out && (dialog.mine || m.mine_author || isDirector) && (
                        <button type="button" title="Удалить сообщение у всех" onClick={() => removeMsg(m)}
                          className="text-slate-400 hover:text-red-600">Удалить</button>
                      )}
                      <span>{inboxTime(m.time)}</span>
                    </div>
                  </div>
                </div>
              </Fragment>
            )
          })}
        </div>

        {err && <div className="shrink-0 px-5 py-1.5 text-[12px]" style={{ background: '#FEF2F2', color: '#B91C1C' }}>{err}</div>}

        <div className="flex shrink-0 items-end gap-2 border-t border-slate-200 px-4 py-3">
          <textarea value={text} onChange={e => setText(e.target.value)} rows={2} disabled={busy}
            onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send() } }}
            placeholder="Сообщение… (Enter — отправить, Shift+Enter — перенос строки)"
            className="flex-1 resize-none rounded-xl px-3 py-2 text-[13px] outline-none"
            style={{ border: '1px solid #E2E8F0' }} />
          <button type="button" onClick={send} disabled={busy || !text.trim()}
            className="rounded-xl px-4 py-2.5 text-[13px] font-semibold text-white disabled:opacity-50"
            style={{ background: '#38BDF8' }}>{busy ? '…' : 'Отправить'}</button>
        </div>
      </div>
    </div>
  )
}

// Кнопка «Проверить MAX» прямо у номера в карточке сделки (Роман 23.10.2026):
// звонильщик договорился по телефону «скину в MAX» — и сразу видит, дойдёт ли,
// а если да, пишет в один клик. Проверка ничего не добавляет в контакты.
let inboxAccountsPromise = null
// Номер MAX, с которого пишем: выбирается в «Чате MAX», помнится в браузере.
const MAX_ACC_KEY = 'maxAccountId'
function chosenMaxId() { try { return localStorage.getItem(MAX_ACC_KEY) } catch { return null } }
function chooseMax(id) {
  try { localStorage.setItem(MAX_ACC_KEY, id) } catch { /* приватный режим */ }
  window.dispatchEvent(new CustomEvent('max-account-change', { detail: id }))
}
function pickMaxAccount(rows, chosen) {
  const list = (rows || []).filter(a => a.channel === 'maks' && a.state === 'connected')
  return list.find(a => a.id === chosen) || list.find(a => a.mine) || list[0] || null
}
const maxAccTitle = a => (a.owner_name && !String(a.label).includes(a.owner_name))
  ? `${a.label} (${a.owner_name})` : a.label
function inboxMaxAccount() {
  if (!inboxAccountsPromise) {
    inboxAccountsPromise = inboxApi('/accounts').catch(() => [])
    setTimeout(() => { inboxAccountsPromise = null }, 60000)
  }
  return inboxAccountsPromise.then(rows => pickMaxAccount(rows, chosenMaxId()))
}

// Выбор номера: сверху «Имя (кому принадлежит)», снизу номер телефона.
function MaxAccountPicker({ accounts, value, onChange }) {
  const [open, setOpen] = useState(false)
  const list = accounts.filter(a => a.channel === 'maks' && a.state === 'connected')
  const cur = list.find(a => a.id === value)
  if (!list.length) return null
  const Row = ({ a }) => (
    <span className="block min-w-0 text-left">
      <span className="block truncate text-[12.5px] font-semibold text-slate-800">{maxAccTitle(a)}</span>
      <span className="block truncate text-[11.5px] text-slate-500">{a.phone || 'номер не указан'}</span>
    </span>
  )
  return (
    <div className="relative px-3 pt-3">
      <button type="button" onClick={() => setOpen(v => !v)}
        className="flex w-full items-center gap-2 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 hover:bg-slate-50"
        title="Аккаунт MAX, с которого пишем">
        <span className="min-w-0 flex-1">{cur && <Row a={cur} />}</span>
        <span className="text-[10px] text-slate-400">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute left-3 right-3 top-full z-20 mt-1 max-h-[260px] overflow-auto rounded-xl border border-slate-200 bg-white py-1 shadow-xl">
            {list.map(a => (
              <button key={a.id} type="button"
                onClick={() => { setOpen(false); onChange(a.id) }}
                className={'block w-full px-3 py-1.5 hover:bg-slate-50' + (a.id === value ? ' bg-violet-50' : '')}>
                <Row a={a} />
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

// Помним, какой диалог открывали по какому номеру: повторная проверка должна
// говорить «диалог уже был» и открывать его, а не заводить контакт заново
// (Роман 23.10.2026).
const MAX_DIALOG_KEY = 'maxDialogByPhone'
function rememberMaxDialog(digits, dialog) {
  try {
    const all = JSON.parse(localStorage.getItem(MAX_DIALOG_KEY) || '{}')
    all[digits] = { id: dialog.id, account_id: dialog.account_id, title: dialog.title, channel: dialog.channel,
      mine: dialog.mine, owner_name: dialog.owner_name, account_label: dialog.account_label, phone: dialog.phone }
    localStorage.setItem(MAX_DIALOG_KEY, JSON.stringify(all))
  } catch { /* приватный режим — просто не помним */ }
}
function rememberedMaxDialog(digits) {
  try { return (JSON.parse(localStorage.getItem(MAX_DIALOG_KEY) || '{}'))[digits] || null }
  catch { return null }
}

function MaxCheckButton({ phone, clientName }) {
  const [busy, setBusy] = useState(false)
  const [res, setRes] = useState(null)
  const digits = String(phone || '').replace(/\D/g, '')
  if (digits.length < 10) return null

  const check = () => {
    if (busy) return
    setBusy(true); setRes(null)
    inboxMaxAccount()
      .then(acc => {
        if (!acc) throw new Error('Рабочий номер MAX не подключён')
        return inboxApi(`/accounts/${acc.id}/contacts/check`, { phone: digits }).then(d => ({ acc, d }))
      })
      .then(({ acc, d }) => {
        if (!d || !d.found) { setRes({ ok: false, text: 'В MAX не найден' }); return }
        // Запоминаем номер, чтобы «Написать» шло с того же аккаунта
        const accName = maxAccTitle(acc)
        // Диалог уже заводили? Сначала смотрим свою память, потом список диалогов по имени.
        const saved = rememberedMaxDialog(digits)
        if (saved && saved.id) {
          setRes({ ok: true, existing: true, dialog: saved, accId: acc.id, text: 'Диалог уже был' })
          return
        }
        return inboxApi('/dialogs?account_id=' + encodeURIComponent(acc.id)).then(list => {
          const name = (d.name || '').trim().toLowerCase()
          const hit = name && (list.dialogs || []).find(x => String(x.title || '').trim().toLowerCase() === name)
          if (hit) {
            rememberMaxDialog(digits, hit)
            setRes({ ok: true, existing: true, dialog: hit, accId: acc.id, text: 'Диалог уже был' })
          } else {
            setRes({ ok: true, existing: false, accId: acc.id, text: 'Есть в MAX' + (d.name ? ': ' + d.name : '') + ' · с ' + accName })
          }
        }).catch(() => setRes({ ok: true, existing: false, accId: acc.id, text: 'Есть в MAX' + (d.name ? ': ' + d.name : '') + ' · с ' + accName }))
      })
      .catch(e => setRes({ ok: false, text: e.status === 404 ? 'Проверка недоступна: обновите приложение чатов' : e.message }))
      .finally(() => setBusy(false))
  }

  const write = () => {
    if (busy || !res) return
    if (res.existing && res.dialog) {       // уже есть — просто открываем
      window.dispatchEvent(new CustomEvent('max-open-dialog', { detail: res.dialog }))
      return
    }
    if (!res.accId) return
    setBusy(true)
    inboxApi(`/accounts/${res.accId}/contacts`, { phone: '+' + digits, name: clientName || 'Клиент' })
      .then(dialog => {
        if (dialog && dialog.id) {
          rememberMaxDialog(digits, dialog)
          window.dispatchEvent(new CustomEvent('max-open-dialog', { detail: dialog }))
          setRes(r => ({ ...r, existing: true, dialog, text: 'Диалог открыт' }))
        }
      })
      .catch(e => setRes(r => ({ ...r, ok: false, text: e.message })))
      .finally(() => setBusy(false))
  }

  return (
    <div className="mt-1 flex flex-wrap items-center gap-1.5">
      <button type="button" onClick={check} disabled={busy}
        className="rounded-md px-2 py-0.5 text-[11px] font-semibold disabled:opacity-50"
        style={{ background: '#EDE9FE', color: '#6D28D9' }}>
        {busy ? '…' : 'Проверить MAX'}
      </button>
      {res && (
        <span className="text-[11px] font-semibold" style={{ color: res.ok ? '#047857' : '#B91C1C' }}>
          {res.text}
        </span>
      )}
      {res && res.ok && (res.accId || res.dialog) && (
        <button type="button" onClick={write} disabled={busy}
          className="rounded-md px-2 py-0.5 text-[11px] font-semibold text-white disabled:opacity-50"
          style={{ background: '#8B5CF6' }}>
          {res.existing ? 'Открыть' : 'Написать'}
        </button>
      )}
    </div>
  )
}

// Найти по номеру (только проверка) и добавить контакт с открытием диалога.
function MaxFindModal({ acc, onClose, onOpen }) {
  const [phone, setPhone] = useState('')
  const [name, setName] = useState('')
  const [res, setRes] = useState(null)
  const [busy, setBusy] = useState(false)
  const digits = phone.replace(/\D/g, '')
  const valid = digits.length >= 10

  const find = () => {
    if (!valid || busy) return
    setBusy(true); setRes(null)
    inboxApi(`/accounts/${acc.id}/contacts/check`, { phone: '+' + digits })
      .then(d => {
        if (d && d.found) { if (!name.trim() && d.name) setName(d.name); setRes({ ok: true, text: 'Есть в MAX' + (d.name ? ': ' + d.name : '') }) }
        else setRes({ ok: false, text: 'В MAX не найден' })
      })
      .catch(e => setRes({ ok: false, text: e.message }))
      .finally(() => setBusy(false))
  }
  const add = () => {
    if (!valid || busy) return
    setBusy(true); setRes(null)
    inboxApi(`/accounts/${acc.id}/contacts`, { phone: '+' + digits, name: name.trim() || 'Клиент' })
      .then(d => { if (d && d.id) onOpen(d) })
      .catch(e => setRes({ ok: false, text: e.message }))
      .finally(() => setBusy(false))
  }
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(15,23,42,0.5)' }} onClick={onClose}>
      <div className="w-full max-w-[380px] rounded-2xl bg-white p-5 shadow-2xl" onClick={e => e.stopPropagation()}>
        <div className="text-[15px] font-semibold text-slate-900">Найти по номеру</div>
        <div className="mt-0.5 text-[11.5px] text-slate-500">С аккаунта: {maxAccTitle(acc)}{acc.phone ? ' · ' + acc.phone : ''}</div>
        <label className="mt-3 block text-[11.5px] font-semibold text-slate-600">Номер телефона
          <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="+7 999 123-45-67" autoFocus
            className="mt-1 w-full rounded-lg border border-slate-200 px-2.5 py-1.5 text-[13px] font-normal outline-none" />
        </label>
        <label className="mt-2 block text-[11.5px] font-semibold text-slate-600">Имя контакта
          <input value={name} onChange={e => setName(e.target.value)} placeholder="Как сохранить контакт" maxLength={80}
            className="mt-1 w-full rounded-lg border border-slate-200 px-2.5 py-1.5 text-[13px] font-normal outline-none" />
        </label>
        {res && (
          <div className="mt-2 rounded-lg px-2.5 py-1.5 text-[12px] font-semibold"
               style={res.ok ? { background: '#ECFDF5', color: '#047857' } : { background: '#FEF2F2', color: '#B91C1C' }}>{res.text}</div>
        )}
        <div className="mt-3 flex gap-2">
          <button type="button" onClick={find} disabled={!valid || busy}
            className="flex-1 rounded-lg py-2 text-[12.5px] font-semibold disabled:opacity-50" style={{ background: '#EDE9FE', color: '#6D28D9' }}>
            {busy ? '…' : 'Найти'}
          </button>
          <button type="button" onClick={add} disabled={!valid || busy}
            className="flex-1 rounded-lg py-2 text-[12.5px] font-semibold text-white disabled:opacity-50" style={{ background: '#8B5CF6' }}>
            Добавить и открыть
          </button>
        </div>
        <button type="button" onClick={onClose} className="mt-2 w-full text-center text-[12px] text-slate-500 hover:text-slate-800">Закрыть</button>
      </div>
    </div>
  )
}

function MaxChatPanel({ phone, clientName }) {
  const [maxMenuOpen, setMaxMenuOpen] = useState(false)
  const [access, setAccess] = useState('loading')      // loading | ok | denied | off
  const [accounts, setAccounts] = useState([])
  const [dialogs, setDialogs] = useState([])
  const [dialogQuery, setDialogQuery] = useState('')   // поиск по диалогам (Роман 22.10.2026)
  const [maxCheck, setMaxCheck] = useState(null)   // «есть ли номер в MAX» (Роман 23.10.2026)
  const [sel, setSel] = useState(null)
  const [msgs, setMsgs] = useState([])
  const [text, setText] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)
  const [chosen, setChosen] = useState(chosenMaxId())
  const [finding, setFinding] = useState(false)
  const acc = pickMaxAccount(accounts, chosen)

  useEffect(() => {
    const on = (e) => setChosen(e.detail)
    window.addEventListener('max-account-change', on)
    return () => window.removeEventListener('max-account-change', on)
  }, [])

  // Доступ + список подключений
  useEffect(() => {
    let alive = true
    inboxApi('/me')
      .then(() => inboxApi('/accounts'))
      .then(rows => { if (alive) { setAccounts(rows || []); setAccess('ok') } })
      .catch(e => { if (alive) setAccess(e.status === 403 ? 'denied' : 'off') })
    return () => { alive = false }
  }, [])

  // Открыть диалог, который завели кнопкой «Написать» у номера в карточке
  useEffect(() => {
    const onOpen = (e) => { if (e.detail && e.detail.id) setSel(e.detail) }
    window.addEventListener('max-open-dialog', onOpen)
    return () => window.removeEventListener('max-open-dialog', onOpen)
  }, [])

  // Диалоги (как в самом приложении — раз в 15 с)
  useEffect(() => {
    if (access !== 'ok') return
    let alive = true
    const load = () => inboxApi(acc ? '/dialogs?account_id=' + encodeURIComponent(acc.id) : '/dialogs?scope=mine')
      .then(d => { if (alive) setDialogs(d.dialogs || []) }).catch(() => {})
    const loadAcc = () => inboxApi('/accounts').then(rows => { if (alive) setAccounts(rows || []) }).catch(() => {})
    setDialogs([]); load(); const iv = setInterval(() => { load(); loadAcc() }, 15000)
    return () => { alive = false; clearInterval(iv) }
  }, [access, acc && acc.id])

  // «Есть ли в MAX»: только проверка номера, контакт не добавляется и диалог
  // не открывается. Звонильщик договорился по телефону «скину в MAX» — и сразу
  // видит, дойдёт ли сообщение (Роман 23.10.2026).
  const checkInMax = () => {
    if (!acc || !phone || busy) return
    setBusy(true); setErr(null); setMaxCheck(null)
    inboxApi(`/accounts/${acc.id}/contacts/check`, { phone: String(phone) })
      .then(d => setMaxCheck(d && d.found
        ? { ok: true, text: 'Есть в MAX' + (d.name ? ': ' + d.name : '') }
        : { ok: false, text: 'В MAX не найден' }))
      .catch(e => setMaxCheck({ ok: false, text: e.status === 404
        ? 'Проверка появится после обновления приложения чатов'
        : e.message }))
      .finally(() => setBusy(false))
  }

  // «Написать клиенту»: добавляем номер в контакты личного аккаунта и открываем диалог
  const writeClient = () => {
    if (!acc || !phone || busy) return
    setBusy(true); setErr(null)
    inboxApi(`/accounts/${acc.id}/contacts`,
      { phone: '+' + String(phone).replace(/\D/g, ''), name: clientName || 'Клиент' })
      .then(d => { if (d && d.id) setSel(d); })
      .catch(e => setErr(e.message))
      .finally(() => setBusy(false))
  }

  // Ввод номера собеседника прямо в списке (MAX отдаёт номер только контактам)
  const editDialogPhone = (d) => {
    const v = window.prompt('Номер собеседника (+79991234567):', d.phone || '')
    if (v === null) return
    setErr(null)
    inboxApi(`/accounts/${d.account_id}/chats/${d.id}/phone`, { phone: v })
      .then(r => setDialogs(list => list.map(x =>
        (x.id === d.id && x.account_id === d.account_id) ? { ...x, phone: r.phone || '' } : x)))
      .catch(e => setErr(e.message))
  }

  const connected = accounts.filter(a => a.state === 'connected')
  const q = dialogQuery.trim().toLowerCase()
  const shownDialogs = q
    ? dialogs.filter(d => `${d.title || ''} ${d.preview || ''} ${d.account_label || ''}`.toLowerCase().includes(q))
    : dialogs
  return (
    <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
      <div className="flex items-center justify-between px-4 pt-4">
        <div className="flex items-center gap-2">
          <span className="flex h-6 w-6 items-center justify-center rounded-lg text-[12px] font-bold text-white"
                style={{ background: '#8B5CF6' }}>M</span>
          <div className="text-[13px] font-semibold text-slate-900">Чат MAX</div>
          <div className="relative">
            <button type="button" title="Номер, с которого пишем клиенту"
              onClick={() => setMaxMenuOpen(v => !v)}
              className="flex h-6 w-6 items-center justify-center rounded-md text-slate-400 hover:bg-slate-100 hover:text-slate-700">
              <IconGear size={14}/>
            </button>
            {maxMenuOpen && (
              <>
                <div className="fixed inset-0 z-10" onClick={() => setMaxMenuOpen(false)} />
                <div className="absolute left-0 top-7 z-20 w-[176px] overflow-hidden rounded-xl bg-white py-1 shadow-xl"
                     style={{ border: '1px solid #E2E8F0' }}>
                  {['Добавить номер', 'Сменить номер'].map(label => (
                    <button key={label} type="button"
                      onClick={() => { setMaxMenuOpen(false); window.open('/inbox-test/admin', '_blank', 'noopener') }}
                      className="block w-full px-3 py-2 text-left text-[12.5px] text-slate-700 hover:bg-slate-50">
                      {label}
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
        <span className="rounded-full px-1.5 py-0.5 text-[10.5px] font-semibold"
              style={{ background: '#F1F5F9', color: '#64748B' }}>{connected.length ? connected.length + ' ном.' : 'нет номера'}</span>
      </div>

      {access === 'loading' && <div className="px-4 py-6 text-center text-[12px] text-slate-400">Загрузка…</div>}

      {access === 'denied' && (
        <div className="px-4 py-5 text-center">
          <div className="text-[12.5px] font-semibold text-slate-700">Доступ ещё не открыт</div>
          <div className="mt-1 text-[11.5px] leading-snug text-slate-500">
            Чат есть, но роль звонильщика пока не добавлена в список разрешённых. Нужна одна правка на стороне приложения чатов.
          </div>
        </div>
      )}

      {access === 'off' && (
        <div className="px-4 py-5 text-center text-[11.5px] leading-snug text-slate-500">
          Приложение чатов недоступно. Откройте <span className="font-semibold">Подключения</span> через шестерёнку.
        </div>
      )}

      {access === 'ok' && <MaxAccountPicker accounts={accounts} value={acc && acc.id} onChange={chooseMax} />}

      {access === 'ok' && (
        <div className="px-3 pt-3">
          <input value={dialogQuery} onChange={e => setDialogQuery(e.target.value)}
            placeholder="Поиск по имени или тексту"
            className="w-full rounded-lg bg-slate-100 px-2.5 py-1.5 text-[12px] outline-none placeholder:text-slate-400" />
        </div>
      )}

      {access === 'ok' && (
        <div className="max-h-[340px] overflow-auto px-2 py-2">
          {shownDialogs.length === 0 && dialogQuery && (
            <div className="px-2 py-4 text-center text-[11.5px] text-slate-500">Ничего не нашлось</div>
          )}
          {dialogs.length === 0 && (
            <div className="px-2 py-4 text-center text-[11.5px] leading-snug text-slate-500">
              {connected.length ? 'Диалогов пока нет' : 'Номер не подключён — шестерёнка → «Добавить номер»'}
            </div>
          )}
          {shownDialogs.map(d => (
            <button key={d.account_id + ':' + d.id} type="button" onClick={() => setSel(d)}
              className="flex w-full items-start gap-2 rounded-lg px-2 py-1.5 text-left hover:bg-slate-50">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-white"
                    style={{ background: d.channel === 'maks' ? '#8B5CF6' : '#38BDF8' }}>
                {(d.title || '?').slice(0, 1).toUpperCase()}
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-baseline justify-between gap-1">
                  <span className="flex min-w-0 items-baseline gap-1.5">
                    <span className="truncate text-[12.5px] font-semibold text-slate-800">{d.title}</span>
                    {d.phone
                      ? <span className="shrink-0 text-[10.5px] text-slate-400">{d.phone}</span>
                      : <span role="button" tabIndex={0} title="Указать номер собеседника"
                          onClick={e => { e.stopPropagation(); editDialogPhone(d) }}
                          onKeyDown={e => { if (e.key === 'Enter') { e.stopPropagation(); editDialogPhone(d) } }}
                          className="shrink-0 cursor-pointer text-[10.5px] text-sky-600 hover:underline">указать номер</span>}
                  </span>
                  <span className="shrink-0 text-[10.5px] text-slate-400">{inboxTime(d.time)}</span>
                </span>
                <span className="block truncate text-[11.5px] text-slate-500">{d.preview || d.account_label}</span>
              </span>
              {d.unread ? <span className="mt-1 shrink-0 rounded-full px-1.5 text-[10px] font-bold text-white" style={{ background: '#38BDF8' }}>{d.unread}</span> : null}
            </button>
          ))}
        </div>
      )}

      {err && <div className="mx-4 mb-2 rounded-lg px-2.5 py-1.5 text-[11.5px]" style={{ background: '#FEF2F2', color: '#B91C1C' }}>{err}</div>}

      {access === 'ok' && (
        <div className="border-t border-slate-100 px-3 py-2.5">
          {maxCheck && (
            <div className="mb-2 rounded-lg px-2.5 py-1.5 text-[11.5px] font-semibold"
                 style={maxCheck.ok
                   ? { background: '#ECFDF5', color: '#047857' }
                   : { background: '#FEF2F2', color: '#B91C1C' }}>
              {maxCheck.text}
            </div>
          )}
          <div className="flex gap-1.5">
            <button type="button" onClick={checkInMax} disabled={!phone || !connected.length || busy}
              className="flex-1 rounded-lg py-2 text-[12px] font-semibold disabled:opacity-50"
              style={{ background: '#EDE9FE', color: '#6D28D9' }}>
              {busy ? '…' : 'Есть в MAX?'}
            </button>
            <button type="button" onClick={writeClient} disabled={!phone || !connected.length || busy}
              className="flex-1 rounded-lg py-2 text-[12px] font-semibold text-white disabled:opacity-50"
              style={{ background: '#8B5CF6' }}>
              {busy ? 'Открываем…' : 'Написать'}
            </button>
          </div>
          <button type="button" onClick={() => setFinding(true)} disabled={!acc}
            className="mt-1.5 w-full rounded-lg py-1.5 text-[12px] font-semibold text-slate-600 hover:bg-slate-50 disabled:opacity-50"
            style={{ border: '1px solid #E2E8F0' }}>Найти по номеру / добавить контакт</button>
          {!phone && <div className="mt-1.5 text-center text-[11px] text-slate-400">Откройте карточку клиента</div>}
        </div>
      )}
    {finding && acc && <MaxFindModal acc={acc} onClose={() => setFinding(false)} onOpen={d => { setFinding(false); setSel(d) }} />}
    {sel && <MaxChatModal dialog={sel} onClose={() => setSel(null)} />}
    </div>
  )
}

// В «Отчёты» переехали рейтинг менеджеров и «Последние звонки» (Роман 22.10.2026).
// Всё остальное на рабочем экране осталось как было: карточка плана, вкладки
// «Текущий клиент / Мои пробные / Биржа» — плюс счёт пробных строкой у вкладок.
function RightColumn({ phone, clientName }) {
  return (
    <aside className="w-[260px] shrink-0 space-y-3">
      <MaxChatPanel phone={phone} clientName={clientName} />
      <CallReviewCard Modal={CallDetailModal} />
    </aside>
  )
}

// Раздел «Отчёты»: рейтинг менеджеров + последние звонки по текущему клиенту.
function ReportsModal({ open, onClose, calls, ranking, currentName, analyzing, onAnalyze, phone }) {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 pt-16"
         style={{ background: 'rgba(15,23,42,0.45)' }} onClick={onClose}>
      <div className="w-full max-w-[880px] max-h-[82vh] overflow-auto rounded-2xl bg-white shadow-2xl"
           onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 flex items-center justify-between border-b border-slate-200 bg-white px-5 py-3">
          <div className="text-[15px] font-semibold text-slate-900">Отчёты</div>
          <button type="button" onClick={onClose}
            className="text-[13px] text-slate-500 hover:text-slate-800">Закрыть</button>
        </div>
        <div className="grid gap-3 p-4 md:grid-cols-2">
          <PlanCard />
          <ManagersRanking ranking={ranking} currentName={currentName} />
          <NextCallsCard calls={calls} analyzing={analyzing} onAnalyze={onAnalyze} phone={phone} />
        </div>

      </div>
    </div>
  )
}

// ─────────── Main ───────────
// ─────────── Рабочее место сделки ───────────
// Состояние карточки сделки + «Добавить сделку» + все действия (анкета с автосохранением,
// доп. дети, Перезвонить/Отказ, запись на пробный, следующий клиент). ОДНА реализация:
// звонильщик (ниже) и переписчик (SupportDashboard mode="writer", Антон 07.09 «сделку
// закрывают как звонильщик»). Ничего из поведения звонильщика не менялось — код перенесён.
export const DealWorkspace = forwardRef(function DealWorkspace({ onDealChange, onBirzhaCreated }, ref) {
  const [deal, setDeal] = useState(null)
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(true)
  const [values, setValues] = useState({})
  const [saveStatus, setSaveStatus] = useState(null)
  const [showAddDeal, setShowAddDeal] = useState(false)
  const [addInitial, setAddInitial] = useState(null)
  const [extraChildren, setExtraChildren] = useState([])
  const [activeChildIdx, setActiveChildIdx] = useState(0)
  // «⭳ Подтянуть данные из старого МК» — та же кнопка, что у сопроводителя на карточке
  // обзвона (pages/pullOldMk.js). Только для лидов из загруженной старой базы
  // (deal.batchName) — новым клиентам не показываем (Антон 15.09).
  const [pulling, setPulling] = useState(false)
  const [pullMsg, setPullMsg] = useState(null)
  // Автоподтяжка при открытии сделки старой базы (Антон 17.09: Попова кнопку не нажимала, имя родителя
  // оставалось пустым). Та же функция, что у кнопки; один раз на сделку, только если имя родителя пусто
  // и историю ещё не подтягивали (в комментарии нет «Старая база:»). Кнопка остаётся.
  const doPullOldMkRef = useRef(null)
  const autoPulledForRef = useRef(null)
  const saveTimerRef = useRef(null)
  const childSaveTimerRef = useRef(null)
  const childPendingRef = useRef({})   // 29.09: накопленные правки ребёнка до отправки
  const onDealChangeRef = useRef(onDealChange)
  onDealChangeRef.current = onDealChange

  // Залить значения из сделки в форму при загрузке
  const hydrateFromDeal = useCallback((d) => {
    if (!d) return
    setExtraChildren(d.extraChildren || [])
    setActiveChildIdx(0)
    setValues({
      phone: d.phone || '',
      parentPhone: d.parentPhone || '',
      parentName: d.parentName || '',
      childName: d.childName || '',
      childPhone: d.childPhone || '',
      city: d.city || '',
      subject: d.subject || '',
      classNum: d.grade || '',
      scoreNow: d.gradeNow || '',
      scorePrev: d.gradePrev || '',
      psyAge: d.psyAge || '',
      psyCharacter: d.psyCharacter || '',
      psyProblem: d.psyProblem || '',
      psyDuration: d.psyDuration || '',
      sourceChannel: d.sourceChannel || '',
      goal: d.goal || '',
      source: d.source || '',
      sourceDetail: d.sourceDetail || '',
      priceOverride: d.priceOverride || '',
      priceOverrideAge: d.priceOverrideAge || '',
      phoneCity: d.phoneCity || '',
      phoneTimezone: d.phoneTimezone || '',
    })
  }, [])

  const loadTasks = (leadId) => {
    api.get('/api/tasks?leadId=' + leadId).then(r => setTasks(r.data || [])).catch(() => {})
  }

  // Единая точка «показать сделку»: форма, задачи, сигнал наружу (звонильщику — разбор звонков)
  const applyDeal = useCallback((d) => {
    setDeal(d)
    if (d) {
      hydrateFromDeal(d)
      loadTasks(d.id)
    } else {
      setValues({})
      setExtraChildren([])
      setActiveChildIdx(0)
      setTasks([])
    }
    if (onDealChangeRef.current) onDealChangeRef.current(d)
  }, [hydrateFromDeal])

  // Автосохранение с дебаунсом 1.5s
  const saveToAmo = useCallback((leadId, patch) => {
    setSaveStatus('saving')
    api.patch('/api/survey/' + leadId, patch)
      .then(() => {
        setSaveStatus('saved')
        setTimeout(() => setSaveStatus(null), 2000)
      })
      .catch(() => setSaveStatus('error'))
  }, [])

  const onUpdate = (key, v) => {
    setValues(prev => {
      const next = { ...prev, [key]: v }
      if (saveTimerRef.current) clearTimeout(saveTimerRef.current)
      if (deal) {
        saveTimerRef.current = setTimeout(() => {
          saveToAmo(deal.id, { [key]: v })
        }, 1500)
      }
      return next
    })
  }

  // Как onUpdate, но сохраняет НЕСКОЛЬКО полей одним запросом (напр. цена+возраст
  // скидки вместе) — иначе два подряд onUpdate() затирают таймер друг друга и
  // сохранится только последнее поле.
  const doPullOldMk = async () => {
    if (!deal) return
    setPulling(true); setPullMsg(null)
    let pulledParent = null
    try {
      const res = await pullOldMk({
        leadId: deal.id, phone: deal.phone || deal.parentPhone, form: values,
        // сохраняем сразу, без дебаунса — чтобы правка соседнего поля не перебила пакет
        applyFields: async (patch) => {
          if (patch.parentName) pulledParent = patch.parentName
          setValues(prev => ({ ...prev, ...patch }))
          await api.patch('/api/survey/' + deal.id, patch)
        },
      })
      setPullMsg(res.msg)
      // имя родителя — и в шапку сделки, не дожидаясь перечитывания
      if (res.found) setDeal(prev => (prev ? { ...prev, parentName: prev.parentName || pulledParent, comment: res.comment ? ((prev.comment ? prev.comment + '\n\n' : '') + res.comment) : prev.comment } : prev))
    } catch (e) {
      setPullMsg('Ошибка: ' + ((e.response && e.response.data && e.response.data.error) || e.message))
    } finally { setPulling(false) }
  }

  doPullOldMkRef.current = doPullOldMk
  useEffect(() => {
    if (!deal || !deal.batchName) return
    if (autoPulledForRef.current === deal.id) return
    if (String(deal.parentName || '').trim()) return
    if (String(deal.comment || '').includes('Старая база:')) return
    autoPulledForRef.current = deal.id
    if (doPullOldMkRef.current) doPullOldMkRef.current()
  }, [deal])

  const onUpdateMany = (patch) => {
    setValues(prev => {
      const next = { ...prev, ...patch }
      if (saveTimerRef.current) clearTimeout(saveTimerRef.current)
      if (deal) {
        // Цена — не набор текста, её ставят одним нажатием «Применить»: сохраняем
        // сразу. С дебаунсом 1.5 с любое следующее действие гасило таймер, и
        // согласованная цена не доезжала до базы (Роман 03.11.2026).
        if (Object.prototype.hasOwnProperty.call(patch, 'priceOverride')) {
          saveToAmo(deal.id, patch)
        } else {
          saveTimerRef.current = setTimeout(() => {
            saveToAmo(deal.id, patch)
          }, 1500)
        }
      }
      return next
    })
  }

  // Доп. дети (вкладки «Ребёнок 2/3...») — тот же паттерн автосохранения 1.5s,
  // но своим эндпоинтом (lead_children, не survey/leads).
  // key — имя поля или объект с несколькими полями (скидка = цена + возраст сразу, 29.09).
  // Правки копятся в childPendingRef и уходят одним PATCH через 1,5 с — раньше таймер
  // перезаписывался и при двух быстрых правках сохранялась только последняя.
  const onUpdateChild = (childId, key, v) => {
    const upd = (key && typeof key === 'object') ? key : { [key]: v }
    setExtraChildren(prev => {
      const next = prev.map(c => c.id === childId ? { ...c, ...upd } : c)
      if (childSaveTimerRef.current) clearTimeout(childSaveTimerRef.current)
      if (deal) {
        const p = childPendingRef.current
        p[childId] = { ...(p[childId] || {}), ...upd }
        childSaveTimerRef.current = setTimeout(() => {
          const all = childPendingRef.current; childPendingRef.current = {}
          for (const [cid, fields] of Object.entries(all)) api.patch(`/api/deals/${deal.id}/children/${cid}`, fields).catch(() => {})
        }, 1500)
      }
      return next
    })
  }
  const onAddChild = () => {
    if (!deal) return
    api.post(`/api/deals/${deal.id}/children`).then(r => {
      setExtraChildren(prev => {
        const next = [...prev, r.data.child]
        setActiveChildIdx(next.length) // сразу переключиться на новую вкладку
        return next
      })
    }).catch(e => alert('Не удалось добавить ребёнка: ' + (e.response?.data?.error || e.message)))
  }
  const onRemoveChild = (childId) => {
    if (!deal) return
    api.delete(`/api/deals/${deal.id}/children/${childId}`).then(() => {
      setExtraChildren(prev => prev.filter(c => c.id !== childId))
      setActiveChildIdx(0)
    }).catch(e => alert('Не удалось убрать ребёнка: ' + (e.response?.data?.error || e.message)))
  }

  useEffect(() => {
    api.get('/api/deals')
      .then(r => { applyDeal(r.data[0] || null); setLoading(false) })
      .catch(() => setLoading(false))
  }, [applyDeal])

  const completeTask = (taskId, result) => {
    api.patch('/api/tasks/' + taskId + '/complete', { result })
      .then(() => { if (deal) loadTasks(deal.id) })
      .catch(() => {})
  }

  const handleRecall = (date, time, note) => {
    const datetime = date + 'T' + time + ':00'
    api.post('/api/tasks', {
      leadId: deal.id, text: note || 'Перезвонить', taskTypeId: 2337280, date: datetime
    }).then(() => api.post('/api/deals/move', { leadId: deal.id, action: 'recall' }))
      .then(() => { window.location.reload() })
      .catch(err => alert('Не удалось поставить задачу «Перезвонить»: ' + (err.response?.data?.error || err.message)))
  }

  const handleReject = (reason) => {
    // «Дорого» (любой предмет) — не обычный отказ: клиента возвращаем в работу
    // тому же менеджеру через час с пометкой предложить скидку (переиспользуем
    // готовый механизм «дозревшего перезвона» — recall/callback). С 13.07 Лидер/скидка
    // не привязаны к предмету, поэтому раньше действовавшая проверка isMathSubject убрана.
    if (reason === 'Дорого') {
      api.post('/api/tasks', {
        leadId: deal.id, text: 'Клиенту было дорого — предложите скидку', taskTypeId: 2337280,
        date: mskDueAt(Date.now() + 3600000)
      }).then(() => api.post('/api/deals/move', { leadId: deal.id, action: 'recall' }))
        .then(() => { window.location.reload() })
        .catch(err => alert('Не удалось поставить задачу: ' + (err.response?.data?.error || err.message)))
      return
    }
    // «Дубль» — не отказ и не перезвон: сделка уходит в отдельную колонку «Дубли» у
    // РОП и больше не участвует ни в очереди менеджера, ни в автопередаче при пропаже
    // (та трогает только calling/callback). Без follow-up задачи — тут больше нечего делать.
    if (reason === 'Дубль') {
      api.post('/api/deals/move', { leadId: deal.id, action: 'duplicate' })
        .then(() => { window.location.reload() })
        .catch(err => alert('Не удалось сохранить: ' + (err.response?.data?.error || err.message)))
      return
    }
    api.post('/api/tasks', {
      leadId: deal.id, text: 'Отказ: ' + reason, taskTypeId: 2337280,
      date: mskDueAt(Date.now() + 86400000)
    }).then(() => api.post('/api/deals/move', { leadId: deal.id, action: 'refuse', reason }))
      .then(() => { window.location.reload() })
      .catch(err => alert('Не удалось сохранить отказ: ' + (err.response?.data?.error || err.message)))
  }

  const handleTrial = async (params) => {
    if (!deal) return null
    // params: { teacherMkId, teacherName, subject, date, time, comment, ... }
    // Запись = бронь ПЛАТФОРМЫ: создаёт ученика + шлёт клиенту SMS-код. После входа
    // клиента платформа сама достраивает урок + ЛК + автозамену (как обычная бронь).
    // CRM в МойКласс напрямую не пишет.
    // Страница больше не перезагружается — карточка клиента остаётся открытой,
    // чтобы можно было сразу записать тот же лид на второй предмет (см. DealCard).
    try {
      const { data } = await api.post('/api/platform/book', {
        leadId:      deal.id,
        teacherMkId: params.teacherMkId,
        teacherName: params.teacherName,
        subject:     params.subject,
        level:       params.level,     // явный ОГЭ/ЕГЭ — fallback, если класс не заполнен
        date:        params.date,
        time:        params.time,
        comment:     (() => {
          const pc = params.childId ? (extraChildren || []).find(c => c.id === params.childId) : null
          const cv = pc || values
          if (!isPsySubject(params.subject) && !isPsySubject(cv.subject)) return params.comment || ''
          const info = [['Возраст', cv.psyAge], ['Характер', cv.psyCharacter], ['Проблема', cv.psyProblem], ['Как давно', cv.psyDuration]]
            .filter(x => isNonEmpty(x[1])).map(x => x[0] + ': ' + x[1]).join('; ')
          return [params.comment || '', info].filter(Boolean).join('\n')
        })(),
        // Без явной скидки цену НЕ передаём вообще — платформа сама честно посчитает
        // её по РЕАЛЬНО выбранному преподу (Лидер → сетка по классу, обычный →
        // база+возраст+класс, см. bookings/index.ts) и не даст записать Лидера
        // дешевле его сетки, даже если сюда прислать заниженную цену (защита
        // добавлена на платформе 2026-07-13). values.priceOverride — только явная
        // ручная скидка менеджера (и она же прячет Лидеров в TrialSignupModal).
        priceOverride: (() => {   // 29.09: у вкладки «Ребёнок 2/3…» — его собственная скидка
          const pc = params.childId ? (extraChildren || []).find(c => c.id === params.childId) : null
          const po = pc ? pc.priceOverride : values.priceOverride
          return isNonEmpty(po) ? Number(po) : null
        })(),
        // Телефон ребёнка (необязательное поле анкеты) — прокидываем в meta брони,
        // чтобы он был виден и в «Мои пробные» (см. GET /api/platform/my-trials).
        childPhone: values.childPhone || '',
        // Вкладка «Ребёнок 2/3...» (id из lead_children) — без неё платформа
        // считает, что это главный ребёнок сделки (см. routes/platform.js /book).
        childId: params.childId || null,
      })
      return { sms_sent: data.sms_sent, booking: data.booking }
    } catch (e) {
      const body = (e.response && e.response.data) || {}
      alert('Не удалось записать:\n' + (body.error || e.message || 'unknown'))
      return null
    }
  }

  // Вызывается кнопкой «Готово, следующий клиент» вместо старой window.location.reload()
  const loadNextDeal = () => api.get('/api/deals').then(r => applyDeal(r.data[0] || null)).catch(() => {})

  // Прямая ссылка на карточку лида: /?lead=ID (раздел «Реклама» кабинета маркетолога, 29.10.2026).
  // Открываем просмотром, как поиск в шапке — без «взять в работу». Ждём, пока отработает первая загрузка.
  useEffect(() => {
    let id = null
    try { id = Number(new URLSearchParams(window.location.search).get('lead')) || null } catch (e) { id = null }
    if (!id) return undefined
    const t = setTimeout(() => { if (ref && ref.current && ref.current.openDealById) ref.current.openDealById(id) }, 1800)
    return () => clearTimeout(t)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Автообновление карточки при возврате на вкладку (Антон 23.07 — реальный
  // случай: телефон визуально пропал на экране из-за автозаполнения браузера,
  // страница сама не обновилась). При возврате на вкладку подтягиваем сделку
  // заново — если что-то на экране разошлось с базой, это само поправится.
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return
      // Открыта карточка: перечитываем только ЕЁ данные (кейс 23.07 — поля визуально
      // разошлись с базой). Другой сделкой открытую не подменяем — см. опрос ниже.
      api.get('/api/deals').then(r => {
        const d = r.data[0] || null
        setDeal(prev => {
          if (!prev) {
            if (d) { hydrateFromDeal(d); loadTasks(d.id); if (onDealChangeRef.current) onDealChangeRef.current(d) }
            return d
          }
          if (d && d.id === prev.id) { hydrateFromDeal(d); return d }
          return prev
        })
      }).catch(() => {})
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => document.removeEventListener('visibilitychange', onVisible)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Периодический опрос новой сделки (Попова 23.07 — «если не выхожу и не захожу
  // заново, лиды не падают»). Раньше сделка подтягивалась ТОЛЬКО при первой
  // загрузке страницы — новый лид, назначенный распределителем в фоне, никак не
  // появлялся, пока вкладка открыта. Раз в 30с тихо проверяем — если пришла ДРУГАЯ
  // сделка (или текущая пропала), подставляем её; если сделка та же — не трогаем
  // экран, чтобы не сбить незасейненный ввод.
  // «Пора звонить»: срок обещанного перезвона наступил, но карточку на экране мы
  // не подменяем (сбьёт ввод) — показываем баннер с кнопкой «Открыть» (Роман 22.10.2026).
  const [duePrompt, setDuePrompt] = useState(null)
  const [dueHidden, setDueHidden] = useState(null)
  useEffect(() => {
    const check = () => api.get('/api/deals/due-now')
      .then(r => {
        const d = r.data && r.data.id ? r.data : null
        setDuePrompt(d && d.id !== (deal && deal.id) ? d : null)
      })
      .catch(() => setDuePrompt(null))
    check()
    const iv = setInterval(check, 30000)
    return () => clearInterval(iv)
  }, [deal])

  useEffect(() => {
    const iv = setInterval(() => {
      api.get('/api/deals').then(r => {
        const d = r.data[0] || null
        if ((d && d.id) === (deal && deal.id)) return
        // Жалоба менеджеров 04.08: «не успели обработать лид — он меняется на другой».
        // Открытую карточку НЕ подменяем более приоритетной сделкой — менеджер сам
        // перейдёт дальше, завершив текущую (отказ/перезвон/пробный). Опрос нужен
        // только чтобы наполнить ПУСТОЙ экран (кейс Поповой 23.07 «лиды не падают»).
        if (deal) return
        applyDeal(d)
      }).catch(() => {})
    }, 30000)
    return () => clearInterval(iv)
  }, [deal]) // eslint-disable-line react-hooks/exhaustive-deps

  const createDeal = (vals) => {
    return api.post('/api/deals', vals)
      .then(r => {
        applyDeal(r.data)
        setShowAddDeal(false)
        setAddInitial(null)
      })
      .catch(e => {
        alert('Не удалось создать сделку:\n' + ((e.response && e.response.data && e.response.data.error) || e.message))
      })
  }

  // Наружу: «Добавить сделку» (шапка), «вернуть сделку» (поиск в шапке), сделка из чата
  // переписчика — по телефону собеседника: нашли → берём в работу (как поиск в шапке
  // звонильщицы), не нашли → «Добавить сделку» с телефоном и именем из чата.
  useImperativeHandle(ref, () => ({
    loadNextDeal,
    // Провалиться в найденную сделку (просмотр), без возврата в работу (Роман 19.10.2026)
    openDealById: async (id) => {
      try {
        const { data } = await api.get(`/api/deals/${id}/view`)
        applyDeal(data)
      } catch (e) {
        alert('Не удалось открыть сделку: ' + (e.response?.data?.error || e.message))
      }
    },
    openAdd: (initial) => { setAddInitial(initial || null); setShowAddDeal(true) },
    openByPhone: async (phone, prefill) => {
      const digits = String(phone || '').replace(/\D/g, '')
      if (digits.length >= 5) {
        try {
          const { data } = await api.get('/api/deals/search', { params: { q: digits } })
          const row = Array.isArray(data) && data[0]
          if (row) {
            await api.post(`/api/deals/${row.id}/take`)
            await loadNextDeal()
            return
          }
        } catch (e) { /* не нашли или платформа занята — заводим новую */ }
      }
      setAddInitial(prefill || { phone })
      setShowAddDeal(true)
    },
  }))

  return (
    <>
      <AddDealModal open={showAddDeal} initial={addInitial}
        onClose={() => { setShowAddDeal(false); setAddInitial(null) }} onCreate={createDeal} />
      {duePrompt && duePrompt.id !== dueHidden && (
        <div className="mb-3 flex flex-wrap items-center gap-3 rounded-xl px-4 py-3"
             style={{ background: '#FEF3C7', border: '1px solid #FCD34D' }}>
          <span className="text-[14px] font-semibold text-amber-900">
            ⏰ Пора звонить: обещали в {String(duePrompt.dueAt || '').slice(11, 16)}
            {duePrompt.name ? ' — ' + duePrompt.name : ''}
            {duePrompt.lateMin > 0 ? ` (опоздание ${duePrompt.lateMin} мин)` : ''}
          </span>
          <button type="button" className="rounded-lg px-3 py-1.5 text-[13px] font-semibold text-white"
            style={{ background: '#B45309' }}
            onClick={() => {
              const id = duePrompt.id
              api.get(`/api/deals/${id}/view`).then(r => { applyDeal(r.data); setDuePrompt(null) })
                .catch(e => alert('Не удалось открыть сделку: ' + (e.response?.data?.error || e.message)))
            }}>Открыть</button>
          <button type="button" className="text-[13px] text-amber-800 underline"
            onClick={() => setDueHidden(duePrompt.id)}>Позже</button>
        </div>
      )}
      {loading ? (
        <div className="rounded-2xl p-12 bg-white text-center text-slate-400 text-[15px]" style={{ border: '2px solid #38BDF8' }}>
          Загрузка...
        </div>
      ) : (
        <DealCard
          key={deal ? deal.id : 'empty'}
          deal={deal} tasks={tasks} values={values}
          onUpdate={onUpdate} onUpdateMany={onUpdateMany} saveStatus={saveStatus}
          onRecall={handleRecall} onReject={handleReject}
          onTrial={handleTrial} onCompleteTask={completeTask}
          onBirzhaCreated={() => { if (onBirzhaCreated) onBirzhaCreated(); loadNextDeal() }}
          onNextClient={loadNextDeal}
          extraChildren={extraChildren} activeChildIdx={activeChildIdx}
          onSwitchChild={setActiveChildIdx} onAddChild={onAddChild} onRemoveChild={onRemoveChild}
          onUpdateChild={onUpdateChild}
          onPullOldMk={doPullOldMk} pulling={pulling} pullMsg={pullMsg}
        />
      )}
    </>
  )
})

export default function CallerDashboard({ onLogout }) {
  const [deal, setDeal] = useState(null)
  const [salary, setSalary] = useState(null)
  const [salaryOpen, setSalaryOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [callsData, setCallsData] = useState({ phone: null, calls: [], analyzing: false })
  const [kpi, setKpi] = useState(null)
  const [leadPeriod, setLeadPeriod] = useState('today')
  const todayIso = new Date().toISOString().slice(0, 10)
  const [rangeFrom, setRangeFrom] = useState(todayIso)
  const [rangeTo, setRangeTo] = useState(todayIso)
  const [ranking, setRanking] = useState(null)
  const [reportsOpen, setReportsOpen] = useState(false)   // раздел «Отчёты» в панели
  const [activeTab, setActiveTab] = useState('deal')
  // после публикации заявки список во вкладке «Биржа» должен обновиться
  const [birzhaRefresh, setBirzhaRefresh] = useState(0)
  const dealRef = useRef(null)
  const name = localStorage.getItem('name')

  const loadCallAnalysis = (leadId) => {
    api.get('/api/call-analysis/' + leadId).then(r => setCallsData(r.data)).catch(() => {})
  }

  const startAnalyze = () => {
    if (!deal) return
    setCallsData(c => ({ ...c, analyzing: true }))
    api.post('/api/call-analysis/' + deal.id + '/analyze')
      .then(() => {
        const iv = setInterval(() => {
          api.get('/api/call-analysis/' + deal.id).then(r => {
            setCallsData(r.data)
            if (!r.data.analyzing) clearInterval(iv)
          }).catch(() => clearInterval(iv))
        }, 5000)
        setTimeout(() => clearInterval(iv), 180000)
      })
      .catch(() => setCallsData(c => ({ ...c, analyzing: false })))
  }

  // Сделка сменилась в рабочем месте (DealWorkspace) — подтянуть разбор звонков по ней
  const onDealChange = useCallback((d) => {
    setDeal(d)
    if (d) { setCallsData({ phone: d.phone || null, calls: [], analyzing: false }); loadCallAnalysis(d.id) }
    else setCallsData({ phone: null, calls: [], analyzing: false })
  }, [])

  // Стрелки «‹ Сегодня ›» на карточке «Лиды» — листают Сегодня→Вчера→Неделя→Месяц→Период по кругу.
  // Один период действует на все 4 карточки по лидам (Лиды/Пробный·спеццена/Отказ·Перезвонить/Конверсия).
  const stepLeadPeriod = (dir) => {
    setLeadPeriod(prev => {
      const idx = LEAD_PERIOD_CYCLE.indexOf(prev)
      return LEAD_PERIOD_CYCLE[(idx + dir + LEAD_PERIOD_CYCLE.length) % LEAD_PERIOD_CYCLE.length]
    })
  }

  useEffect(() => {
    const params = new URLSearchParams({ period: leadPeriod })
    if (leadPeriod === 'range') { params.set('from', rangeFrom); params.set('to', rangeTo) }
    api.get('/api/kpi?' + params.toString()).then(r => setKpi(r.data)).catch(() => {})
  }, [leadPeriod, rangeFrom, rangeTo])

  useEffect(() => {
    api.get('/api/managers-ranking').then(r => setRanking(r.data)).catch(() => {})
    api.get('/api/salary')
      .then(r => { setSalary(r.data); setLoading(false) })
      .catch(() => setLoading(false))
  }, [])

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center text-slate-400 text-[15px]" style={{ background: '#F2F2F7' }}>
      Загрузка...
    </div>
  )

  const ls = kpi && kpi.leadStats
  const rangeInputs = leadPeriod === 'range' ? (
    <div className="mt-2 flex items-center gap-1.5">
      <input type="date" value={rangeFrom} onChange={e => setRangeFrom(e.target.value)}
        className="w-full text-[11px] border rounded-md px-1.5 py-1 outline-none"
        style={{ borderColor: '#E2E8F0', color: '#334155' }} />
      <span className="text-[10px] text-slate-400">—</span>
      <input type="date" value={rangeTo} onChange={e => setRangeTo(e.target.value)}
        className="w-full text-[11px] border rounded-md px-1.5 py-1 outline-none"
        style={{ borderColor: '#E2E8F0', color: '#334155' }} />
    </div>
  ) : null
  const KPIS = [
    { label: 'Лиды', corner: <PeriodStepper period={leadPeriod} onStep={stepLeadPeriod} />, value: ls ? ls.total : '—', extra: rangeInputs },
    { label: 'Пробный · спеццена', split: ls ? [{ n: ls.trial, k: 'пробный' }, { n: ls.spec, k: 'спеццена' }] : [{ k: 'пробный' }, { k: 'спеццена' }] },
    { label: 'Отказ · Перезвонить', split: ls ? [{ n: ls.rejected, k: 'отказ' }, { n: ls.callback, k: 'перезвон.' }] : [{ k: 'отказ' }, { k: 'перезвон.' }] },
    { label: 'Конверсия', split: ls ? [{ n: ls.convTrial !== null ? ls.convTrial + '%' : '—', k: 'пробных' }, { n: ls.convSpec !== null ? ls.convSpec + '%' : '—', k: 'спеццена' }] : [{ k: 'пробных' }, { k: 'спеццена' }] },
    { label: 'Примерная ЗП', value: salary ? salary.salary.toLocaleString('ru-RU') + ' ₽' : '—',
      sub: salary ? 'оклад ' + (salary.oklad || 0).toLocaleString('ru-RU') + ' + премия ' + (salary.bonus || 0).toLocaleString('ru-RU') : '...',
      hint: salary ? (salaryOpen ? 'нажмите, чтобы свернуть' : 'нажмите, чтобы посмотреть из чего') : null,
      onClick: () => setSalaryOpen(v => !v), tone: 'green' },
  ]

  const CALLS = callsData.calls || []

  return (
    <div className="min-h-screen" style={{ background: '#F2F2F7' }}>
      <TopBar name={name} onLogout={onLogout}
        onAddDeal={() => { if (dealRef.current) dealRef.current.openAdd() }}
        onOpenDeal={(id) => { if (dealRef.current) dealRef.current.openDealById(id) }}
        onOpenReports={() => setReportsOpen(true)}
        onDealReturned={() => { if (dealRef.current) dealRef.current.loadNextDeal() }} />
      <ReportsModal open={reportsOpen} onClose={() => setReportsOpen(false)}
        calls={CALLS} ranking={ranking} currentName={name}
        analyzing={callsData.analyzing} onAnalyze={startAnalyze} phone={callsData.phone} />
      <main className="p-4 space-y-3 max-w-[1440px] mx-auto">
        <section className="grid grid-cols-5 gap-3">
          {KPIS.map((k, i) => <KpiCard key={i} k={k} idx={i} />)}
        </section>
        {salaryOpen && <SalaryPanel salary={salary} onClose={() => setSalaryOpen(false)} />}
        <section className="flex gap-3 items-start">
          <div className="flex-1 min-w-0">
            <div className="mb-3 flex flex-wrap items-center gap-2">
              <div className="flex w-fit gap-1.5 rounded-xl bg-white p-1" style={{ border: '1px solid #E4E7EC' }}>
                <button onClick={() => setActiveTab('deal')}
                  className="text-[13px] font-semibold px-3.5 py-2 rounded-lg transition-colors"
                  style={activeTab === 'deal' ? { background: '#F0F9FF', color: '#0369A1' } : { color: '#667085' }}>
                  Текущий клиент
                </button>
                <button onClick={() => setActiveTab('myTrials')}
                  className="text-[13px] font-semibold px-3.5 py-2 rounded-lg transition-colors"
                  style={activeTab === 'myTrials' ? { background: '#F0F9FF', color: '#0369A1' } : { color: '#667085' }}>
                  Мои пробные
                </button>
                <button onClick={() => setActiveTab('birzha')}
                  className="text-[13px] font-semibold px-3.5 py-2 rounded-lg transition-colors"
                  style={activeTab === 'birzha' ? { background: '#F0F9FF', color: '#0369A1' } : { color: '#667085' }}>
                  Биржа
                </button>
              </div>
              {/* Счёт пробных этого менеджера по плану — рядом с вкладками (Роман 22.10.2026) */}
              <MyTrialsStat />
            </div>
            {/* Рабочее место сделки не размонтируем при смене вкладки — карточка и незасейвленный ввод остаются */}
            <div style={{ display: activeTab === 'deal' ? 'block' : 'none' }}>
              <DealWorkspace ref={dealRef} onDealChange={onDealChange} onBirzhaCreated={() => setBirzhaRefresh(v => v + 1)} />
            </div>
            {activeTab === 'birzha' && <BirzhaTab refreshKey={birzhaRefresh} />}
            {activeTab === 'myTrials' && <TrialsBoard />}
          </div>
          <RightColumn phone={callsData.phone} clientName={(deal && (deal.parentName || deal.childName)) || ''} />
        </section>
        <div className="text-[11px] text-slate-400 text-center pt-4 pb-2 font-mono">
          CRM HUB · ЛК Звонильщика · v 3.0.0
        </div>
      </main>
    </div>
  )
}

// Окно полного разбора звонка — используется и сопроводителем (SupportDashboard),
// одна копия на всех (правило «не плодить код»)
export { CallDetailModal }
